var map = {
	"./android.png": 46078,
	"./app-store-button.png": 441749,
	"./appIcons.png": 358154,
	"./arrow-left.png": 85420,
	"./avatar-placeholder.png": 300808,
	"./axia/bfbfbf.svg": 579256,
	"./axia/blueicon.png": 767056,
	"./axia/boomea-bg.jpg": 13430,
	"./axia/boomea-logo.svg": 485081,
	"./axia/boomea/about.svg": 100929,
	"./axia/boomea/account-settings-white.svg": 630479,
	"./axia/boomea/account-settings.svg": 300895,
	"./axia/boomea/add-presence.svg": 994379,
	"./axia/boomea/advaced-settings.svg": 417836,
	"./axia/boomea/advanced-notifications.svg": 660875,
	"./axia/boomea/appchat.png": 115706,
	"./axia/boomea/appphone.png": 950630,
	"./axia/boomea/apprecord.png": 179783,
	"./axia/boomea/assign-contact.svg": 312814,
	"./axia/boomea/blue-lock.svg": 37598,
	"./axia/boomea/blue-unlock.svg": 276015,
	"./axia/boomea/boomea-white.svg": 391841,
	"./axia/boomea/boomealogo.png": 820831,
	"./axia/boomea/calendar-blue.svg": 399477,
	"./axia/boomea/calendar-gray.svg": 954136,
	"./axia/boomea/calendar.svg": 496076,
	"./axia/boomea/call-recording-blue-phone.svg": 13686,
	"./axia/boomea/call-recording-grey-phone.svg": 226863,
	"./axia/boomea/chat-access-blue.svg": 19256,
	"./axia/boomea/chat-access-white.svg": 576411,
	"./axia/boomea/chat.svg": 6356,
	"./axia/boomea/chevron-arrow-down.svg": 182112,
	"./axia/boomea/clear-search.svg": 87246,
	"./axia/boomea/clipboard.svg": 81156,
	"./axia/boomea/communication-history/call.svg": 177432,
	"./axia/boomea/communication-history/chat.svg": 929402,
	"./axia/boomea/communication-history/inbound-rejected.svg": 993414,
	"./axia/boomea/communication-history/incoming.svg": 304716,
	"./axia/boomea/communication-history/mic.svg": 540449,
	"./axia/boomea/communication-history/missed-call.svg": 662724,
	"./axia/boomea/communication-history/out-going.svg": 265013,
	"./axia/boomea/communication-history/sms.svg": 657247,
	"./axia/boomea/communication-history/voicemail.svg": 652427,
	"./axia/boomea/community-white.svg": 951601,
	"./axia/boomea/contact-details/birthday.svg": 268253,
	"./axia/boomea/contact-details/callrecording.svg": 181843,
	"./axia/boomea/contact-details/chat.svg": 278424,
	"./axia/boomea/contact-details/cog.svg": 848015,
	"./axia/boomea/contact-details/envelope.svg": 360698,
	"./axia/boomea/contact-details/history.svg": 584650,
	"./axia/boomea/contact-details/location.svg": 216647,
	"./axia/boomea/contact-details/meeting.svg": 338785,
	"./axia/boomea/contact-details/missed-call.svg": 831118,
	"./axia/boomea/contact-details/others.svg": 859295,
	"./axia/boomea/contact-details/outgoing-call.svg": 374677,
	"./axia/boomea/contact-details/phone.svg": 484274,
	"./axia/boomea/contact-details/received-call.svg": 859176,
	"./axia/boomea/contact-details/received-mail.svg": 547053,
	"./axia/boomea/contact-details/rejected-call.svg": 615569,
	"./axia/boomea/contact-details/sent-chat.svg": 257575,
	"./axia/boomea/contact-details/voice-mail.svg": 722760,
	"./axia/boomea/contact-details/voicemail.svg": 259373,
	"./axia/boomea/contact-details/website.svg": 300649,
	"./axia/boomea/contact-details/white-down.svg": 225534,
	"./axia/boomea/contact-plus-white.svg": 761271,
	"./axia/boomea/contact-settings-white.svg": 896016,
	"./axia/boomea/contacts-icon-blue.png": 897565,
	"./axia/boomea/contacts-icon-blue.svg": 149282,
	"./axia/boomea/contacts-icon-white.svg": 943497,
	"./axia/boomea/contacts/chat-comment.svg": 869634,
	"./axia/boomea/contacts/chat-off.OLD.png": 854196,
	"./axia/boomea/contacts/chat-off.png": 514089,
	"./axia/boomea/contacts/chat-offOLD2.png": 717386,
	"./axia/boomea/contacts/chat-on.OLD.png": 704626,
	"./axia/boomea/contacts/chat-on.png": 162247,
	"./axia/boomea/contacts/chat-onOLD2.png": 432216,
	"./axia/boomea/contacts/chat.svg": 389374,
	"./axia/boomea/contacts/contact-assign.svg": 772610,
	"./axia/boomea/contacts/contact-plus.svg": 4465,
	"./axia/boomea/contacts/contact-search.svg": 315757,
	"./axia/boomea/contacts/contact-settings-blue.svg": 362415,
	"./axia/boomea/contacts/contact-settings.svg": 449278,
	"./axia/boomea/contacts/download.svg": 640204,
	"./axia/boomea/contacts/email-off.png": 463727,
	"./axia/boomea/contacts/email-offOLD2.png": 427456,
	"./axia/boomea/contacts/email-on.png": 59237,
	"./axia/boomea/contacts/email-onOLD2.png": 219694,
	"./axia/boomea/contacts/email.png": 361371,
	"./axia/boomea/contacts/google-plus.svg": 699338,
	"./axia/boomea/contacts/office365.svg": 87444,
	"./axia/boomea/contacts/phone-off.OLD.png": 39326,
	"./axia/boomea/contacts/phone-off.png": 643411,
	"./axia/boomea/contacts/phone-offOLD2.svg": 753867,
	"./axia/boomea/contacts/phone-on.OLD.png": 492132,
	"./axia/boomea/contacts/phone-on.png": 820953,
	"./axia/boomea/contacts/phone-onOLD2.svg": 703349,
	"./axia/boomea/contacts/toggle-down-white.svg": 891301,
	"./axia/boomea/contacts/toggle-down.svg": 243089,
	"./axia/boomea/contacts/toggle-up-white.svg": 957754,
	"./axia/boomea/contacts/toggle-up.svg": 830990,
	"./axia/boomea/copy-link-blue.svg": 226875,
	"./axia/boomea/copy-link.svg": 949602,
	"./axia/boomea/delete-white.svg": 470111,
	"./axia/boomea/delete.svg": 186415,
	"./axia/boomea/desktop-notifications.svg": 559037,
	"./axia/boomea/desktop-settings.svg": 968776,
	"./axia/boomea/down-round.svg": 168769,
	"./axia/boomea/download.svg": 791305,
	"./axia/boomea/edit-presence.svg": 300496,
	"./axia/boomea/fax/cancelled.svg": 236771,
	"./axia/boomea/fax/fax-icon.svg": 609015,
	"./axia/boomea/fax/inbound-fax.svg": 773627,
	"./axia/boomea/fax/outbound-fax.svg": 420120,
	"./axia/boomea/fax/pdf.svg": 187972,
	"./axia/boomea/fax/success-icon.svg": 999,
	"./axia/boomea/filter-cross.png": 142004,
	"./axia/boomea/filter-plus.png": 178674,
	"./axia/boomea/fullscreen.svg": 826189,
	"./axia/boomea/grey-lock.svg": 937293,
	"./axia/boomea/head-cancel.svg": 697959,
	"./axia/boomea/head-phones.svg": 596282,
	"./axia/boomea/help.svg": 513703,
	"./axia/boomea/history.svg": 787126,
	"./axia/boomea/icons/audio.svg": 260023,
	"./axia/boomea/icons/blue/history.svg": 181358,
	"./axia/boomea/icons/blue/meeting.svg": 889029,
	"./axia/boomea/icons/blue/mic.svg": 486711,
	"./axia/boomea/icons/blue/voice-mail.svg": 165476,
	"./axia/boomea/icons/chat.svg": 86597,
	"./axia/boomea/icons/company-directory.svg": 492442,
	"./axia/boomea/icons/conference-center.svg": 217369,
	"./axia/boomea/icons/conference-center2.svg": 113289,
	"./axia/boomea/icons/contacts-icon-white.svg": 564754,
	"./axia/boomea/icons/contacts.svg": 384868,
	"./axia/boomea/icons/fax-icon.svg": 393558,
	"./axia/boomea/icons/head-cancel.svg": 551956,
	"./axia/boomea/icons/head-phones.svg": 443157,
	"./axia/boomea/icons/history.svg": 472857,
	"./axia/boomea/icons/meeting.svg": 420290,
	"./axia/boomea/icons/mic.svg": 551444,
	"./axia/boomea/icons/notification-white.svg": 817322,
	"./axia/boomea/icons/operator-console.svg": 556487,
	"./axia/boomea/icons/other.svg": 794515,
	"./axia/boomea/icons/phone-disable.svg": 433198,
	"./axia/boomea/icons/phone.svg": 194337,
	"./axia/boomea/icons/presence.svg": 251640,
	"./axia/boomea/icons/quick-call.svg": 400757,
	"./axia/boomea/icons/sms.svg": 32314,
	"./axia/boomea/icons/video.svg": 272600,
	"./axia/boomea/icons/voice-mail.svg": 35733,
	"./axia/boomea/icons/word.svg": 719955,
	"./axia/boomea/icons/zip.svg": 416784,
	"./axia/boomea/join-meeting.svg": 495034,
	"./axia/boomea/logo.svg": 978487,
	"./axia/boomea/logout.svg": 497508,
	"./axia/boomea/meeting-3.png": 205778,
	"./axia/boomea/meeting-history.svg": 445098,
	"./axia/boomea/meeting.svg": 929597,
	"./axia/boomea/mic.svg": 102271,
	"./axia/boomea/mobile-blue-notifications.svg": 674430,
	"./axia/boomea/mobile-notifications.svg": 220247,
	"./axia/boomea/move-v.svg": 200536,
	"./axia/boomea/notification-white.svg": 473971,
	"./axia/boomea/operator-console.svg": 780630,
	"./axia/boomea/operator-console/available.svg": 549146,
	"./axia/boomea/operator-console/call-orange.png": 995135,
	"./axia/boomea/operator-console/call-orange.svg": 255472,
	"./axia/boomea/operator-console/call-red-yellow.gif": 366756,
	"./axia/boomea/operator-console/call-yellow.gif": 935442,
	"./axia/boomea/operator-console/call-yellow.png": 625253,
	"./axia/boomea/operator-console/intercom.svg": 163596,
	"./axia/boomea/operator-console/on-call.svg": 940067,
	"./axia/boomea/operator-console/ringing.gif": 878017,
	"./axia/boomea/operator-console/ringing.svg": 31357,
	"./axia/boomea/parking-slot-disabled.svg": 256520,
	"./axia/boomea/parking-slot.svg": 617735,
	"./axia/boomea/passcode.svg": 279614,
	"./axia/boomea/pencil.svg": 391037,
	"./axia/boomea/phone-toggle-off.svg": 990071,
	"./axia/boomea/phone.svg": 80486,
	"./axia/boomea/pickup.svg": 457450,
	"./axia/boomea/presence-blue.svg": 820058,
	"./axia/boomea/profile.svg": 377237,
	"./axia/boomea/quick-call.svg": 315280,
	"./axia/boomea/reload.svg": 397149,
	"./axia/boomea/remove.svg": 553450,
	"./axia/boomea/save.svg": 513125,
	"./axia/boomea/search.svg": 348414,
	"./axia/boomea/settings.svg": 761450,
	"./axia/boomea/share-blue.svg": 521800,
	"./axia/boomea/share.svg": 336987,
	"./axia/boomea/short-cut.svg": 234619,
	"./axia/boomea/start-meeting.svg": 168126,
	"./axia/boomea/time.svg": 980009,
	"./axia/boomea/toggle-off.svg": 512318,
	"./axia/boomea/visibility-off.svg": 923150,
	"./axia/boomea/visibility.svg": 842510,
	"./axia/boomea/voice-mail.svg": 681660,
	"./axia/boomea/webphone/contacts-icon.svg": 64898,
	"./axia/boomea/white/add-presence.svg": 514005,
	"./axia/boomea/white/edit-presence.svg": 779566,
	"./axia/boomea/white/filter-cross.png": 555230,
	"./axia/boomea/white/filter-plus.png": 708608,
	"./axia/boomea/white/toggle-off.svg": 606152,
	"./axia/compdir/company-directory-blue.svg": 714633,
	"./axia/compdir/company-directory3.svg": 400187,
	"./axia/compdir/compdir-call-gray.png": 844713,
	"./axia/compdir/compdir-call-green.png": 749827,
	"./axia/compdir/compdir-call-red.png": 320435,
	"./axia/compdir/compdir-call-white.png": 269397,
	"./axia/compdir/compdir-call-yellow.png": 146156,
	"./axia/compdir/pencil-alt-solid.svg": 477458,
	"./axia/compdir/sms-off.svg": 570992,
	"./axia/compdir/sms-original.svg": 313160,
	"./axia/compdir/sms.svg": 812140,
	"./axia/compdir/trash-alt-solid.svg": 100325,
	"./axia/email.png": 454511,
	"./axia/favicon/android-chrome-192x192.png": 529911,
	"./axia/favicon/apple-touch-icon-120x120.png": 636827,
	"./axia/favicon/apple-touch-icon-144x144.png": 707631,
	"./axia/favicon/apple-touch-icon-152x152.png": 364463,
	"./axia/favicon/apple-touch-icon-57x57.png": 731279,
	"./axia/favicon/apple-touch-icon-60x60.png": 921987,
	"./axia/favicon/apple-touch-icon-72x72.png": 182197,
	"./axia/favicon/apple-touch-icon-76x76.png": 102797,
	"./axia/favicon/favicon-16x16.png": 575775,
	"./axia/favicon/favicon-32x32.png": 594135,
	"./axia/favicon/favicon-96x96.png": 101087,
	"./axia/favicon/redfavicon-16x16.png": 523810,
	"./axia/icon50x50.png": 301708,
	"./axia/icon64x64.png": 900334,
	"./axia/icon_WS.png": 144323,
	"./axia/icons/audio.png": 854434,
	"./axia/icons/audio.svg": 238925,
	"./axia/icons/calendar-gray.svg": 252025,
	"./axia/icons/chat.svg": 266439,
	"./axia/icons/code.png": 289505,
	"./axia/icons/code.svg": 464870,
	"./axia/icons/email.png": 481628,
	"./axia/icons/excel.png": 320789,
	"./axia/icons/excel.svg": 345226,
	"./axia/icons/generic.png": 391995,
	"./axia/icons/generic.svg": 263772,
	"./axia/icons/image.png": 46375,
	"./axia/icons/image.svg": 632616,
	"./axia/icons/lock.png": 379515,
	"./axia/icons/logo.svg": 474772,
	"./axia/icons/patch.png": 545754,
	"./axia/icons/pdf.png": 623814,
	"./axia/icons/pdf.svg": 430193,
	"./axia/icons/phone-green.svg": 61245,
	"./axia/icons/phone-grey.svg": 610989,
	"./axia/icons/phone-red.svg": 188497,
	"./axia/icons/phone-yellow.svg": 162276,
	"./axia/icons/ppt.png": 432904,
	"./axia/icons/ppt.svg": 596711,
	"./axia/icons/presentation.svg": 394689,
	"./axia/icons/search-icon.svg": 996845,
	"./axia/icons/user.png": 829855,
	"./axia/icons/video.png": 712789,
	"./axia/icons/video.svg": 703050,
	"./axia/icons/word.png": 751794,
	"./axia/icons/word.svg": 17469,
	"./axia/icons/zip.svg": 571998,
	"./axia/lightbluelogo.svg": 674661,
	"./axia/load.gif": 250160,
	"./axia/load.png": 320131,
	"./axia/lock.png": 684466,
	"./axia/logo-email.png": 732937,
	"./axia/logo.png": 295874,
	"./axia/logoWhite.png": 893287,
	"./axia/logo_compact.png": 402128,
	"./axia/read.svg": 606124,
	"./axia/status_green.png": 430829,
	"./axia/status_red.png": 984909,
	"./axia/status_yellow.png": 414622,
	"./axia/user.png": 8670,
	"./axia/waiting/chat.png": 456725,
	"./axia/waiting/company-directory.png": 256664,
	"./axia/waiting/conference-center.png": 246687,
	"./axia/waiting/contacts.png": 36880,
	"./axia/waiting/meetings.png": 726309,
	"./axia/waiting/presence.png": 161456,
	"./axia/waiting/schedule-meeting.png": 491604,
	"./axia/waiting/webphone.png": 511589,
	"./bing.mp3": 984398,
	"./boomea/bfbfbf.svg": 340994,
	"./boomea/blueicon.png": 85734,
	"./boomea/boomea-bg.jpg": 33148,
	"./boomea/boomea-logo.svg": 68551,
	"./boomea/boomea/about.svg": 272931,
	"./boomea/boomea/account-settings-white.svg": 925385,
	"./boomea/boomea/account-settings.svg": 264309,
	"./boomea/boomea/add-presence.svg": 856089,
	"./boomea/boomea/advaced-settings.svg": 897234,
	"./boomea/boomea/advanced-notifications.svg": 185889,
	"./boomea/boomea/appchat.png": 878996,
	"./boomea/boomea/appphone.png": 450288,
	"./boomea/boomea/apprecord.png": 830837,
	"./boomea/boomea/assign-contact.svg": 76884,
	"./boomea/boomea/blue-lock.svg": 126088,
	"./boomea/boomea/blue-unlock.svg": 492501,
	"./boomea/boomea/boomea-white.svg": 875351,
	"./boomea/boomea/boomealogo.png": 172361,
	"./boomea/boomea/calendar-blue.svg": 570375,
	"./boomea/boomea/calendar-gray.svg": 682678,
	"./boomea/boomea/calendar.svg": 384774,
	"./boomea/boomea/call-recording-blue-phone.svg": 561952,
	"./boomea/boomea/call-recording-grey-phone.svg": 314485,
	"./boomea/boomea/chat-access-blue.svg": 530230,
	"./boomea/boomea/chat-access-white.svg": 689669,
	"./boomea/boomea/chat.svg": 145646,
	"./boomea/boomea/chevron-arrow-down.svg": 709750,
	"./boomea/boomea/clear-search.svg": 954576,
	"./boomea/boomea/clipboard.svg": 744846,
	"./boomea/boomea/communication-history/call.svg": 703562,
	"./boomea/boomea/communication-history/chat.svg": 92980,
	"./boomea/boomea/communication-history/inbound-rejected.svg": 860528,
	"./boomea/boomea/communication-history/incoming.svg": 208222,
	"./boomea/boomea/communication-history/mic.svg": 707487,
	"./boomea/boomea/communication-history/missed-call.svg": 519850,
	"./boomea/boomea/communication-history/out-going.svg": 550483,
	"./boomea/boomea/communication-history/sms.svg": 220161,
	"./boomea/boomea/communication-history/voicemail.svg": 172209,
	"./boomea/boomea/community-white.svg": 220587,
	"./boomea/boomea/contact-details/birthday.svg": 742531,
	"./boomea/boomea/contact-details/callrecording.svg": 856481,
	"./boomea/boomea/contact-details/chat.svg": 326122,
	"./boomea/boomea/contact-details/cog.svg": 260565,
	"./boomea/boomea/contact-details/envelope.svg": 131060,
	"./boomea/boomea/contact-details/history.svg": 726384,
	"./boomea/boomea/contact-details/location.svg": 754381,
	"./boomea/boomea/contact-details/meeting.svg": 263891,
	"./boomea/boomea/contact-details/missed-call.svg": 876596,
	"./boomea/boomea/contact-details/others.svg": 469209,
	"./boomea/boomea/contact-details/outgoing-call.svg": 275599,
	"./boomea/boomea/contact-details/phone.svg": 198532,
	"./boomea/boomea/contact-details/received-call.svg": 764474,
	"./boomea/boomea/contact-details/received-mail.svg": 174451,
	"./boomea/boomea/contact-details/rejected-call.svg": 85859,
	"./boomea/boomea/contact-details/sent-chat.svg": 592973,
	"./boomea/boomea/contact-details/voice-mail.svg": 251266,
	"./boomea/boomea/contact-details/voicemail.svg": 917275,
	"./boomea/boomea/contact-details/website.svg": 443847,
	"./boomea/boomea/contact-details/white-down.svg": 82276,
	"./boomea/boomea/contact-plus-white.svg": 503221,
	"./boomea/boomea/contact-settings-white.svg": 273210,
	"./boomea/boomea/contacts-icon-blue.png": 698259,
	"./boomea/boomea/contacts-icon-blue.svg": 728164,
	"./boomea/boomea/contacts-icon-white.svg": 505519,
	"./boomea/boomea/contacts/chat-comment.svg": 533356,
	"./boomea/boomea/contacts/chat-off.OLD.png": 553666,
	"./boomea/boomea/contacts/chat-off.png": 728407,
	"./boomea/boomea/contacts/chat-offOLD2.png": 434632,
	"./boomea/boomea/contacts/chat-on.OLD.png": 315448,
	"./boomea/boomea/contacts/chat-on.png": 579309,
	"./boomea/boomea/contacts/chat-onOLD2.png": 605590,
	"./boomea/boomea/contacts/chat.svg": 413140,
	"./boomea/boomea/contacts/contact-assign.svg": 402884,
	"./boomea/boomea/contacts/contact-plus.svg": 16599,
	"./boomea/boomea/contacts/contact-search.svg": 821579,
	"./boomea/boomea/contacts/contact-settings-blue.svg": 445201,
	"./boomea/boomea/contacts/contact-settings.svg": 166816,
	"./boomea/boomea/contacts/download.svg": 210230,
	"./boomea/boomea/contacts/email-off.png": 365917,
	"./boomea/boomea/contacts/email-offOLD2.png": 898086,
	"./boomea/boomea/contacts/email-on.png": 38507,
	"./boomea/boomea/contacts/email-onOLD2.png": 372820,
	"./boomea/boomea/contacts/email.png": 382093,
	"./boomea/boomea/contacts/google-plus.svg": 957956,
	"./boomea/boomea/contacts/office365.svg": 928610,
	"./boomea/boomea/contacts/phone-off.OLD.png": 515484,
	"./boomea/boomea/contacts/phone-off.png": 865921,
	"./boomea/boomea/contacts/phone-offOLD2.svg": 145773,
	"./boomea/boomea/contacts/phone-on.OLD.png": 719418,
	"./boomea/boomea/contacts/phone-on.png": 597087,
	"./boomea/boomea/contacts/phone-onOLD2.svg": 537983,
	"./boomea/boomea/contacts/toggle-down-white.svg": 165575,
	"./boomea/boomea/contacts/toggle-down.svg": 657127,
	"./boomea/boomea/contacts/toggle-up-white.svg": 816824,
	"./boomea/boomea/contacts/toggle-up.svg": 299992,
	"./boomea/boomea/copy-link-blue.svg": 919765,
	"./boomea/boomea/copy-link.svg": 490668,
	"./boomea/boomea/delete-white.svg": 663857,
	"./boomea/boomea/delete.svg": 684589,
	"./boomea/boomea/desktop-notifications.svg": 499647,
	"./boomea/boomea/desktop-settings.svg": 633170,
	"./boomea/boomea/down-round.svg": 635295,
	"./boomea/boomea/download.svg": 250044,
	"./boomea/boomea/edit-presence.svg": 621218,
	"./boomea/boomea/fax/cancelled.svg": 866649,
	"./boomea/boomea/fax/fax-icon.svg": 749357,
	"./boomea/boomea/fax/inbound-fax.svg": 604857,
	"./boomea/boomea/fax/outbound-fax.svg": 265314,
	"./boomea/boomea/fax/pdf.svg": 649026,
	"./boomea/boomea/fax/success-icon.svg": 759837,
	"./boomea/boomea/filter-cross.png": 764986,
	"./boomea/boomea/filter-plus.png": 197404,
	"./boomea/boomea/fullscreen.svg": 380663,
	"./boomea/boomea/grey-lock.svg": 235691,
	"./boomea/boomea/head-cancel.svg": 974941,
	"./boomea/boomea/head-phones.svg": 38984,
	"./boomea/boomea/help.svg": 459237,
	"./boomea/boomea/history.svg": 83124,
	"./boomea/boomea/icons/audio.svg": 261073,
	"./boomea/boomea/icons/blue/history.svg": 730820,
	"./boomea/boomea/icons/blue/meeting.svg": 995079,
	"./boomea/boomea/icons/blue/mic.svg": 57677,
	"./boomea/boomea/icons/blue/sms.svg": 873627,
	"./boomea/boomea/icons/blue/voice-mail.svg": 586174,
	"./boomea/boomea/icons/chat.svg": 637139,
	"./boomea/boomea/icons/code.svg": 955042,
	"./boomea/boomea/icons/company-directory.svg": 259604,
	"./boomea/boomea/icons/conference-center.svg": 301759,
	"./boomea/boomea/icons/conference-center2.svg": 544399,
	"./boomea/boomea/icons/contacts-icon-white.svg": 869564,
	"./boomea/boomea/icons/contacts.svg": 233746,
	"./boomea/boomea/icons/excel.svg": 653726,
	"./boomea/boomea/icons/fax-icon.svg": 959856,
	"./boomea/boomea/icons/generic.svg": 441048,
	"./boomea/boomea/icons/gz.svg": 579754,
	"./boomea/boomea/icons/head-cancel.svg": 67334,
	"./boomea/boomea/icons/head-phones.svg": 58535,
	"./boomea/boomea/icons/history.svg": 17139,
	"./boomea/boomea/icons/meeting.svg": 154016,
	"./boomea/boomea/icons/mic.svg": 470334,
	"./boomea/boomea/icons/notification-white.svg": 101656,
	"./boomea/boomea/icons/operator-console.svg": 922325,
	"./boomea/boomea/icons/other.svg": 898961,
	"./boomea/boomea/icons/patch.png": 351822,
	"./boomea/boomea/icons/pdf.svg": 883853,
	"./boomea/boomea/icons/phone-disable.svg": 867812,
	"./boomea/boomea/icons/phone.svg": 454591,
	"./boomea/boomea/icons/ppt.svg": 861515,
	"./boomea/boomea/icons/presence.svg": 227586,
	"./boomea/boomea/icons/quick-call.svg": 373715,
	"./boomea/boomea/icons/sms.svg": 838896,
	"./boomea/boomea/icons/video.svg": 264726,
	"./boomea/boomea/icons/voice-mail.svg": 114539,
	"./boomea/boomea/icons/word.svg": 921289,
	"./boomea/boomea/icons/zip.svg": 730090,
	"./boomea/boomea/join-meeting.svg": 72892,
	"./boomea/boomea/logo.svg": 465961,
	"./boomea/boomea/logout.svg": 164934,
	"./boomea/boomea/meeting-3.png": 660436,
	"./boomea/boomea/meeting-history.svg": 297448,
	"./boomea/boomea/meeting.svg": 13463,
	"./boomea/boomea/mic.svg": 432957,
	"./boomea/boomea/mobile-blue-notifications.svg": 627632,
	"./boomea/boomea/mobile-notifications.svg": 264977,
	"./boomea/boomea/move-v.svg": 971282,
	"./boomea/boomea/notification-white.svg": 740557,
	"./boomea/boomea/operator-console.svg": 441872,
	"./boomea/boomea/operator-console/available.svg": 145280,
	"./boomea/boomea/operator-console/call-orange.png": 485333,
	"./boomea/boomea/operator-console/call-orange.svg": 509770,
	"./boomea/boomea/operator-console/call-red-yellow.gif": 263166,
	"./boomea/boomea/operator-console/call-yellow.gif": 396272,
	"./boomea/boomea/operator-console/call-yellow.png": 466243,
	"./boomea/boomea/operator-console/intercom.svg": 58830,
	"./boomea/boomea/operator-console/on-call.svg": 55533,
	"./boomea/boomea/operator-console/ringing.gif": 995679,
	"./boomea/boomea/operator-console/ringing.svg": 424255,
	"./boomea/boomea/parking-slot-disabled.svg": 980602,
	"./boomea/boomea/parking-slot.svg": 648349,
	"./boomea/boomea/passcode.svg": 521580,
	"./boomea/boomea/pencil.svg": 895595,
	"./boomea/boomea/phone-toggle-off.svg": 503821,
	"./boomea/boomea/phone.svg": 82736,
	"./boomea/boomea/pickup.svg": 545864,
	"./boomea/boomea/presence-blue.svg": 733080,
	"./boomea/boomea/profile.svg": 228219,
	"./boomea/boomea/quick-call.svg": 443538,
	"./boomea/boomea/reload.svg": 377363,
	"./boomea/boomea/remove.svg": 885924,
	"./boomea/boomea/save.svg": 526923,
	"./boomea/boomea/search.svg": 306344,
	"./boomea/boomea/settings.svg": 94515,
	"./boomea/boomea/share-blue.svg": 890586,
	"./boomea/boomea/share.svg": 112285,
	"./boomea/boomea/short-cut.svg": 880029,
	"./boomea/boomea/start-meeting.svg": 234568,
	"./boomea/boomea/time.svg": 693903,
	"./boomea/boomea/toggle-off-white.svg": 761252,
	"./boomea/boomea/toggle-off.svg": 902692,
	"./boomea/boomea/visibility-off.svg": 324972,
	"./boomea/boomea/visibility.svg": 367912,
	"./boomea/boomea/voice-mail.svg": 331630,
	"./boomea/boomea/webphone/contacts-icon.svg": 481724,
	"./boomea/boomea/white/add-presence.svg": 475531,
	"./boomea/boomea/white/edit-presence.svg": 884624,
	"./boomea/boomea/white/filter-cross.png": 623156,
	"./boomea/boomea/white/filter-plus.png": 929842,
	"./boomea/boomea/white/toggle-off.svg": 859454,
	"./boomea/compdir/company-directory-blue.svg": 453763,
	"./boomea/compdir/company-directory3.svg": 55333,
	"./boomea/compdir/compdir-call-gray.png": 165115,
	"./boomea/compdir/compdir-call-green.png": 264061,
	"./boomea/compdir/compdir-call-red.png": 63709,
	"./boomea/compdir/compdir-call-white.png": 74167,
	"./boomea/compdir/compdir-call-yellow.png": 61870,
	"./boomea/compdir/pencil-alt-solid.svg": 395396,
	"./boomea/compdir/sms-off.svg": 214122,
	"./boomea/compdir/sms-original.svg": 228514,
	"./boomea/compdir/sms.svg": 335290,
	"./boomea/compdir/trash-alt-solid.svg": 822243,
	"./boomea/email.png": 324513,
	"./boomea/favicon/android-chrome-192x192.png": 809141,
	"./boomea/favicon/apple-touch-icon-120x120.png": 8397,
	"./boomea/favicon/apple-touch-icon-144x144.png": 580433,
	"./boomea/favicon/apple-touch-icon-152x152.png": 979401,
	"./boomea/favicon/apple-touch-icon-57x57.png": 583353,
	"./boomea/favicon/apple-touch-icon-60x60.png": 931469,
	"./boomea/favicon/apple-touch-icon-72x72.png": 619367,
	"./boomea/favicon/apple-touch-icon-76x76.png": 984071,
	"./boomea/favicon/favicon-16x16.png": 136981,
	"./boomea/favicon/favicon-32x32.png": 26181,
	"./boomea/favicon/favicon-96x96.png": 27093,
	"./boomea/favicon/redfavicon-16x16.png": 173400,
	"./boomea/icon50x50.png": 113602,
	"./boomea/icon64x64.png": 282204,
	"./boomea/icon_WS.png": 598733,
	"./boomea/icons/audio.png": 301604,
	"./boomea/icons/audio.svg": 81251,
	"./boomea/icons/calendar-gray.svg": 219511,
	"./boomea/icons/chat.svg": 475033,
	"./boomea/icons/code.png": 505779,
	"./boomea/icons/code.svg": 19332,
	"./boomea/icons/conference-call.png": 809765,
	"./boomea/icons/email.png": 75722,
	"./boomea/icons/excel.png": 963951,
	"./boomea/icons/excel.svg": 316928,
	"./boomea/icons/generic.png": 803649,
	"./boomea/icons/generic.svg": 607302,
	"./boomea/icons/gz.svg": 101732,
	"./boomea/icons/image.png": 749665,
	"./boomea/icons/image.svg": 925030,
	"./boomea/icons/lock.png": 193177,
	"./boomea/icons/logo.svg": 213990,
	"./boomea/icons/patch.png": 223284,
	"./boomea/icons/pdf.png": 419888,
	"./boomea/icons/pdf.svg": 409503,
	"./boomea/icons/phone-green.svg": 62427,
	"./boomea/icons/phone-grey.svg": 277355,
	"./boomea/icons/phone-red.svg": 404407,
	"./boomea/icons/phone-yellow.svg": 67578,
	"./boomea/icons/ppt.png": 918222,
	"./boomea/icons/ppt.svg": 625353,
	"./boomea/icons/presentation.svg": 214083,
	"./boomea/icons/search-icon.svg": 954023,
	"./boomea/icons/user.png": 234825,
	"./boomea/icons/video.png": 342459,
	"./boomea/icons/video.svg": 730588,
	"./boomea/icons/word.png": 689992,
	"./boomea/icons/word.svg": 853799,
	"./boomea/icons/zip.svg": 887460,
	"./boomea/lightbluelogo.svg": 871311,
	"./boomea/load.gif": 294770,
	"./boomea/load.png": 527109,
	"./boomea/lock.png": 210708,
	"./boomea/logo-email.png": 464315,
	"./boomea/logo.png": 719148,
	"./boomea/logoWhite.png": 595497,
	"./boomea/logo_compact.png": 377906,
	"./boomea/read.svg": 301618,
	"./boomea/status_green.png": 727827,
	"./boomea/status_red.png": 765059,
	"./boomea/status_yellow.png": 134780,
	"./boomea/user.png": 645276,
	"./boomea/waiting/chat.png": 185519,
	"./boomea/waiting/company-directory.png": 9086,
	"./boomea/waiting/conference-center.png": 119529,
	"./boomea/waiting/contacts.png": 263994,
	"./boomea/waiting/meetings.png": 511927,
	"./boomea/waiting/presence.png": 105590,
	"./boomea/waiting/schedule-meeting.png": 444810,
	"./boomea/waiting/webphone.png": 386019,
	"./bootstrap-colorpicker/alpha-horizontal.png": 436203,
	"./bootstrap-colorpicker/alpha.png": 649388,
	"./bootstrap-colorpicker/hue-horizontal.png": 344993,
	"./bootstrap-colorpicker/hue.png": 626914,
	"./bootstrap-colorpicker/saturation.png": 903598,
	"./call/add_new_call.png": 653645,
	"./call/back.svg": 993426,
	"./call/call-end-icon.svg": 132851,
	"./call/dialer.png": 52731,
	"./call/incoming-call.png": 232391,
	"./call/merge.png": 159974,
	"./call/missed-call.png": 205974,
	"./call/out-call.png": 320165,
	"./call/split.png": 687218,
	"./callend.mp3": 305211,
	"./callstart.mp3": 112044,
	"./circles.png": 543332,
	"./close.png": 731647,
	"./closeSidebar.png": 186947,
	"./ding.mp3": 124924,
	"./dots.png": 995375,
	"./ellen-silhouette.png": 252564,
	"./emoji-sheets/activity-1.png": 649720,
	"./emoji-sheets/activity-2.png": 961683,
	"./emoji-sheets/custom-1.png": 808338,
	"./emoji-sheets/flags-1.png": 473086,
	"./emoji-sheets/flags-2.png": 75189,
	"./emoji-sheets/flags-3.png": 322924,
	"./emoji-sheets/flags-4.png": 499171,
	"./emoji-sheets/flags-5.png": 735066,
	"./emoji-sheets/flags-6.png": 156177,
	"./emoji-sheets/foods-1.png": 583652,
	"./emoji-sheets/foods-2.png": 497215,
	"./emoji-sheets/nature-1.png": 262430,
	"./emoji-sheets/nature-2.png": 429781,
	"./emoji-sheets/nature-3.png": 60684,
	"./emoji-sheets/nature-4.png": 990851,
	"./emoji-sheets/objects-1.png": 364175,
	"./emoji-sheets/objects-2.png": 145268,
	"./emoji-sheets/objects-3.png": 366397,
	"./emoji-sheets/objects-4.png": 970050,
	"./emoji-sheets/people-1.png": 259370,
	"./emoji-sheets/people-2.png": 208353,
	"./emoji-sheets/people-3.png": 240088,
	"./emoji-sheets/people-4.png": 515255,
	"./emoji-sheets/people-5.png": 372238,
	"./emoji-sheets/people-6.png": 244037,
	"./emoji-sheets/people-7.png": 714620,
	"./emoji-sheets/places-1.png": 597203,
	"./emoji-sheets/places-2.png": 251448,
	"./emoji-sheets/places-3.png": 472577,
	"./emoji-sheets/skintone-1.png": 847492,
	"./emoji-sheets/skintone-10.png": 449246,
	"./emoji-sheets/skintone-11.png": 167559,
	"./emoji-sheets/skintone-12.png": 247500,
	"./emoji-sheets/skintone-13.png": 616597,
	"./emoji-sheets/skintone-14.png": 860090,
	"./emoji-sheets/skintone-15.png": 177667,
	"./emoji-sheets/skintone-16.png": 892392,
	"./emoji-sheets/skintone-17.png": 790257,
	"./emoji-sheets/skintone-18.png": 78326,
	"./emoji-sheets/skintone-19.png": 674655,
	"./emoji-sheets/skintone-2.png": 132767,
	"./emoji-sheets/skintone-20.png": 277711,
	"./emoji-sheets/skintone-21.png": 992614,
	"./emoji-sheets/skintone-22.png": 576381,
	"./emoji-sheets/skintone-23.png": 355252,
	"./emoji-sheets/skintone-24.png": 647243,
	"./emoji-sheets/skintone-25.png": 883586,
	"./emoji-sheets/skintone-3.png": 78966,
	"./emoji-sheets/skintone-4.png": 728937,
	"./emoji-sheets/skintone-5.png": 604736,
	"./emoji-sheets/skintone-6.png": 502299,
	"./emoji-sheets/skintone-7.png": 180754,
	"./emoji-sheets/skintone-8.png": 709909,
	"./emoji-sheets/skintone-9.png": 798284,
	"./emoji-sheets/symbols-1.png": 843396,
	"./emoji-sheets/symbols-2.png": 798047,
	"./emoji-sheets/symbols-3.png": 201718,
	"./emoji-sheets/symbols-4.png": 301545,
	"./emoji-sheets/symbols-5.png": 846720,
	"./emoji-sheets/symbols-6.png": 625051,
	"./emoji-sheets/symbols-7.png": 210834,
	"./emoji/0023-fe0f-20e3.png": 433200,
	"./emoji/002a-fe0f-20e3.png": 225062,
	"./emoji/0030-fe0f-20e3.png": 830336,
	"./emoji/0031-fe0f-20e3.png": 551053,
	"./emoji/0032-fe0f-20e3.png": 352646,
	"./emoji/0033-fe0f-20e3.png": 109891,
	"./emoji/0034-fe0f-20e3.png": 786484,
	"./emoji/0035-fe0f-20e3.png": 298961,
	"./emoji/0036-fe0f-20e3.png": 820890,
	"./emoji/0037-fe0f-20e3.png": 525751,
	"./emoji/0038-fe0f-20e3.png": 150456,
	"./emoji/0039-fe0f-20e3.png": 416101,
	"./emoji/00a9-fe0f.png": 769818,
	"./emoji/00ae-fe0f.png": 916086,
	"./emoji/1f004-fe0f.png": 121583,
	"./emoji/1f0cf.png": 742892,
	"./emoji/1f170-fe0f.png": 770039,
	"./emoji/1f171-fe0f.png": 611104,
	"./emoji/1f17e-fe0f.png": 34964,
	"./emoji/1f17f-fe0f.png": 264629,
	"./emoji/1f18e.png": 204207,
	"./emoji/1f191.png": 757812,
	"./emoji/1f192.png": 680271,
	"./emoji/1f193.png": 395174,
	"./emoji/1f194.png": 800153,
	"./emoji/1f195.png": 84400,
	"./emoji/1f196.png": 49803,
	"./emoji/1f197.png": 286146,
	"./emoji/1f198.png": 187013,
	"./emoji/1f199.png": 869500,
	"./emoji/1f19a.png": 479812,
	"./emoji/1f1e6-1f1e9.png": 122224,
	"./emoji/1f1e6-1f1ea.png": 690024,
	"./emoji/1f1e6-1f1eb.png": 975299,
	"./emoji/1f1e6-1f1ec.png": 174074,
	"./emoji/1f1e6-1f1ee.png": 45132,
	"./emoji/1f1e6-1f1f1.png": 105621,
	"./emoji/1f1e6-1f1f2.png": 268894,
	"./emoji/1f1e6-1f1f4.png": 381416,
	"./emoji/1f1e6-1f1f6.png": 653562,
	"./emoji/1f1e6-1f1f7.png": 243395,
	"./emoji/1f1e6-1f1f8.png": 243204,
	"./emoji/1f1e6-1f1f9.png": 906445,
	"./emoji/1f1e6-1f1fa.png": 650181,
	"./emoji/1f1e6-1f1fc.png": 921399,
	"./emoji/1f1e6-1f1fd.png": 129880,
	"./emoji/1f1e6-1f1ff.png": 665514,
	"./emoji/1f1e7-1f1e6.png": 532642,
	"./emoji/1f1e7-1f1e7.png": 423147,
	"./emoji/1f1e7-1f1e9.png": 437669,
	"./emoji/1f1e7-1f1ea.png": 987437,
	"./emoji/1f1e7-1f1eb.png": 80406,
	"./emoji/1f1e7-1f1ec.png": 858495,
	"./emoji/1f1e7-1f1ed.png": 999840,
	"./emoji/1f1e7-1f1ee.png": 971017,
	"./emoji/1f1e7-1f1ef.png": 605874,
	"./emoji/1f1e7-1f1f1.png": 48896,
	"./emoji/1f1e7-1f1f2.png": 827227,
	"./emoji/1f1e7-1f1f3.png": 413010,
	"./emoji/1f1e7-1f1f4.png": 285517,
	"./emoji/1f1e7-1f1f6.png": 223,
	"./emoji/1f1e7-1f1f7.png": 403894,
	"./emoji/1f1e7-1f1f8.png": 115825,
	"./emoji/1f1e7-1f1f9.png": 217960,
	"./emoji/1f1e7-1f1fc.png": 851906,
	"./emoji/1f1e7-1f1fe.png": 323572,
	"./emoji/1f1e7-1f1ff.png": 246031,
	"./emoji/1f1e8-1f1e6.png": 11065,
	"./emoji/1f1e8-1f1e8.png": 624727,
	"./emoji/1f1e8-1f1e9.png": 679150,
	"./emoji/1f1e8-1f1eb.png": 613997,
	"./emoji/1f1e8-1f1ec.png": 843748,
	"./emoji/1f1e8-1f1ed.png": 523963,
	"./emoji/1f1e8-1f1ee.png": 809138,
	"./emoji/1f1e8-1f1f0.png": 720638,
	"./emoji/1f1e8-1f1f1.png": 989479,
	"./emoji/1f1e8-1f1f2.png": 570476,
	"./emoji/1f1e8-1f1f3.png": 322741,
	"./emoji/1f1e8-1f1f4.png": 982618,
	"./emoji/1f1e8-1f1f7.png": 403729,
	"./emoji/1f1e8-1f1fa.png": 751127,
	"./emoji/1f1e8-1f1fb.png": 9372,
	"./emoji/1f1e8-1f1fc.png": 575909,
	"./emoji/1f1e8-1f1fd.png": 209034,
	"./emoji/1f1e8-1f1fe.png": 364243,
	"./emoji/1f1e8-1f1ff.png": 18488,
	"./emoji/1f1e9-1f1ea.png": 665003,
	"./emoji/1f1e9-1f1ef.png": 715092,
	"./emoji/1f1e9-1f1f0.png": 619939,
	"./emoji/1f1e9-1f1f2.png": 276945,
	"./emoji/1f1e9-1f1f4.png": 346343,
	"./emoji/1f1e9-1f1ff.png": 449125,
	"./emoji/1f1ea-1f1e8.png": 264018,
	"./emoji/1f1ea-1f1ea.png": 469875,
	"./emoji/1f1ea-1f1ec.png": 51745,
	"./emoji/1f1ea-1f1ed.png": 885006,
	"./emoji/1f1ea-1f1f7.png": 531828,
	"./emoji/1f1ea-1f1f8.png": 827123,
	"./emoji/1f1ea-1f1f9.png": 976362,
	"./emoji/1f1ea-1f1fa.png": 621266,
	"./emoji/1f1eb-1f1ee.png": 274904,
	"./emoji/1f1eb-1f1ef.png": 449395,
	"./emoji/1f1eb-1f1f0.png": 339856,
	"./emoji/1f1eb-1f1f2.png": 363170,
	"./emoji/1f1eb-1f1f4.png": 303764,
	"./emoji/1f1eb-1f1f7.png": 808879,
	"./emoji/1f1ec-1f1e6.png": 602574,
	"./emoji/1f1ec-1f1e7.png": 745591,
	"./emoji/1f1ec-1f1e9.png": 391961,
	"./emoji/1f1ec-1f1ea.png": 654001,
	"./emoji/1f1ec-1f1eb.png": 477754,
	"./emoji/1f1ec-1f1ec.png": 67587,
	"./emoji/1f1ec-1f1ed.png": 534540,
	"./emoji/1f1ec-1f1ee.png": 446165,
	"./emoji/1f1ec-1f1f1.png": 17748,
	"./emoji/1f1ec-1f1f2.png": 192239,
	"./emoji/1f1ec-1f1f3.png": 153222,
	"./emoji/1f1ec-1f1f5.png": 80016,
	"./emoji/1f1ec-1f1f6.png": 967659,
	"./emoji/1f1ec-1f1f7.png": 746530,
	"./emoji/1f1ec-1f1f8.png": 524709,
	"./emoji/1f1ec-1f1f9.png": 441820,
	"./emoji/1f1ec-1f1fa.png": 435300,
	"./emoji/1f1ec-1f1fc.png": 875222,
	"./emoji/1f1ec-1f1fe.png": 337184,
	"./emoji/1f1ed-1f1f0.png": 578386,
	"./emoji/1f1ed-1f1f3.png": 126569,
	"./emoji/1f1ed-1f1f7.png": 908365,
	"./emoji/1f1ed-1f1f9.png": 245315,
	"./emoji/1f1ed-1f1fa.png": 726283,
	"./emoji/1f1ee-1f1e8.png": 261886,
	"./emoji/1f1ee-1f1e9.png": 14375,
	"./emoji/1f1ee-1f1ea.png": 784687,
	"./emoji/1f1ee-1f1f1.png": 222910,
	"./emoji/1f1ee-1f1f2.png": 825013,
	"./emoji/1f1ee-1f1f3.png": 742124,
	"./emoji/1f1ee-1f1f4.png": 672291,
	"./emoji/1f1ee-1f1f6.png": 575377,
	"./emoji/1f1ee-1f1f7.png": 819080,
	"./emoji/1f1ee-1f1f8.png": 325631,
	"./emoji/1f1ee-1f1f9.png": 547542,
	"./emoji/1f1ef-1f1ea.png": 184088,
	"./emoji/1f1ef-1f1f2.png": 215598,
	"./emoji/1f1ef-1f1f4.png": 912184,
	"./emoji/1f1ef-1f1f5.png": 133313,
	"./emoji/1f1f0-1f1ea.png": 1935,
	"./emoji/1f1f0-1f1ec.png": 300605,
	"./emoji/1f1f0-1f1ed.png": 607810,
	"./emoji/1f1f0-1f1ee.png": 371467,
	"./emoji/1f1f0-1f1f2.png": 294293,
	"./emoji/1f1f0-1f1f3.png": 382668,
	"./emoji/1f1f0-1f1f5.png": 842234,
	"./emoji/1f1f0-1f1f7.png": 570088,
	"./emoji/1f1f0-1f1fc.png": 309436,
	"./emoji/1f1f0-1f1fe.png": 854186,
	"./emoji/1f1f0-1f1ff.png": 803169,
	"./emoji/1f1f1-1f1e6.png": 213045,
	"./emoji/1f1f1-1f1e7.png": 130156,
	"./emoji/1f1f1-1f1e8.png": 210043,
	"./emoji/1f1f1-1f1ee.png": 581358,
	"./emoji/1f1f1-1f1f0.png": 864818,
	"./emoji/1f1f1-1f1f7.png": 669677,
	"./emoji/1f1f1-1f1f8.png": 911898,
	"./emoji/1f1f1-1f1f9.png": 676003,
	"./emoji/1f1f1-1f1fa.png": 948139,
	"./emoji/1f1f1-1f1fb.png": 576848,
	"./emoji/1f1f1-1f1fe.png": 172719,
	"./emoji/1f1f2-1f1e6.png": 663250,
	"./emoji/1f1f2-1f1e8.png": 280780,
	"./emoji/1f1f2-1f1e9.png": 192405,
	"./emoji/1f1f2-1f1ea.png": 986365,
	"./emoji/1f1f2-1f1ec.png": 984143,
	"./emoji/1f1f2-1f1ed.png": 57648,
	"./emoji/1f1f2-1f1f0.png": 924761,
	"./emoji/1f1f2-1f1f1.png": 209008,
	"./emoji/1f1f2-1f1f2.png": 174411,
	"./emoji/1f1f2-1f1f3.png": 410754,
	"./emoji/1f1f2-1f1f4.png": 103549,
	"./emoji/1f1f2-1f1f5.png": 882420,
	"./emoji/1f1f2-1f1f6.png": 804879,
	"./emoji/1f1f2-1f1f7.png": 36134,
	"./emoji/1f1f2-1f1f8.png": 275937,
	"./emoji/1f1f2-1f1f9.png": 3224,
	"./emoji/1f1f2-1f1fa.png": 607744,
	"./emoji/1f1f2-1f1fb.png": 386075,
	"./emoji/1f1f2-1f1fc.png": 488210,
	"./emoji/1f1f2-1f1fd.png": 844365,
	"./emoji/1f1f2-1f1fe.png": 604420,
	"./emoji/1f1f2-1f1ff.png": 559071,
	"./emoji/1f1f3-1f1e6.png": 416871,
	"./emoji/1f1f3-1f1e8.png": 210249,
	"./emoji/1f1f3-1f1ea.png": 962232,
	"./emoji/1f1f3-1f1eb.png": 307987,
	"./emoji/1f1f3-1f1ec.png": 152778,
	"./emoji/1f1f3-1f1ee.png": 953116,
	"./emoji/1f1f3-1f1f1.png": 169989,
	"./emoji/1f1f3-1f1f4.png": 861592,
	"./emoji/1f1f3-1f1f5.png": 134305,
	"./emoji/1f1f3-1f1f7.png": 36083,
	"./emoji/1f1f3-1f1fa.png": 875733,
	"./emoji/1f1f3-1f1ff.png": 119226,
	"./emoji/1f1f4-1f1f2.png": 35641,
	"./emoji/1f1f5-1f1e6.png": 67585,
	"./emoji/1f1f5-1f1ea.png": 548606,
	"./emoji/1f1f5-1f1eb.png": 150709,
	"./emoji/1f1f5-1f1ec.png": 398444,
	"./emoji/1f1f5-1f1ed.png": 574691,
	"./emoji/1f1f5-1f1f0.png": 436166,
	"./emoji/1f1f5-1f1f1.png": 17711,
	"./emoji/1f1f5-1f1f2.png": 996244,
	"./emoji/1f1f5-1f1f3.png": 217373,
	"./emoji/1f1f5-1f1f7.png": 38585,
	"./emoji/1f1f5-1f1f8.png": 249198,
	"./emoji/1f1f5-1f1f9.png": 948695,
	"./emoji/1f1f5-1f1fc.png": 26797,
	"./emoji/1f1f5-1f1fe.png": 394235,
	"./emoji/1f1f6-1f1e6.png": 747054,
	"./emoji/1f1f7-1f1ea.png": 948892,
	"./emoji/1f1f7-1f1f4.png": 248692,
	"./emoji/1f1f7-1f1f8.png": 700120,
	"./emoji/1f1f7-1f1fa.png": 694889,
	"./emoji/1f1f7-1f1fc.png": 468251,
	"./emoji/1f1f8-1f1e6.png": 257032,
	"./emoji/1f1f8-1f1e7.png": 767249,
	"./emoji/1f1f8-1f1e8.png": 289942,
	"./emoji/1f1f8-1f1e9.png": 186879,
	"./emoji/1f1f8-1f1ea.png": 114647,
	"./emoji/1f1f8-1f1ec.png": 939429,
	"./emoji/1f1f8-1f1ed.png": 572554,
	"./emoji/1f1f8-1f1ee.png": 727763,
	"./emoji/1f1f8-1f1f0.png": 964207,
	"./emoji/1f1f8-1f1f1.png": 925190,
	"./emoji/1f1f8-1f1f2.png": 706397,
	"./emoji/1f1f8-1f1f3.png": 789716,
	"./emoji/1f1f8-1f1f4.png": 739627,
	"./emoji/1f1f8-1f1f7.png": 368336,
	"./emoji/1f1f8-1f1f8.png": 471895,
	"./emoji/1f1f8-1f1f9.png": 42670,
	"./emoji/1f1f8-1f1fb.png": 461165,
	"./emoji/1f1f8-1f1fd.png": 887483,
	"./emoji/1f1f8-1f1fe.png": 656306,
	"./emoji/1f1f8-1f1ff.png": 987273,
	"./emoji/1f1f9-1f1e8.png": 451507,
	"./emoji/1f1f9-1f1e9.png": 296298,
	"./emoji/1f1f9-1f1eb.png": 271785,
	"./emoji/1f1f9-1f1ec.png": 147584,
	"./emoji/1f1f9-1f1ed.png": 159263,
	"./emoji/1f1f9-1f1ef.png": 537229,
	"./emoji/1f1f9-1f1f0.png": 84346,
	"./emoji/1f1f9-1f1f1.png": 674179,
	"./emoji/1f1f9-1f1f2.png": 812200,
	"./emoji/1f1f9-1f1f3.png": 260593,
	"./emoji/1f1f9-1f1f4.png": 216030,
	"./emoji/1f1f9-1f1f7.png": 52757,
	"./emoji/1f1f9-1f1f9.png": 328795,
	"./emoji/1f1f9-1f1fb.png": 77016,
	"./emoji/1f1f9-1f1fc.png": 45281,
	"./emoji/1f1f9-1f1ff.png": 67900,
	"./emoji/1f1fa-1f1e6.png": 384613,
	"./emoji/1f1fa-1f1ec.png": 702216,
	"./emoji/1f1fa-1f1f8.png": 387338,
	"./emoji/1f1fa-1f1fe.png": 878591,
	"./emoji/1f1fa-1f1ff.png": 965028,
	"./emoji/1f1fb-1f1e6.png": 921474,
	"./emoji/1f1fb-1f1e8.png": 539004,
	"./emoji/1f1fb-1f1ea.png": 324685,
	"./emoji/1f1fb-1f1ec.png": 946719,
	"./emoji/1f1fb-1f1ee.png": 542889,
	"./emoji/1f1fb-1f1f3.png": 201010,
	"./emoji/1f1fb-1f1fa.png": 104464,
	"./emoji/1f1fc-1f1eb.png": 681763,
	"./emoji/1f1fc-1f1f8.png": 846884,
	"./emoji/1f1fd-1f1f0.png": 828891,
	"./emoji/1f1fe-1f1ea.png": 275086,
	"./emoji/1f1fe-1f1f9.png": 557063,
	"./emoji/1f1ff-1f1e6.png": 124958,
	"./emoji/1f1ff-1f1f2.png": 130431,
	"./emoji/1f1ff-1f1fc.png": 995142,
	"./emoji/1f201.png": 942880,
	"./emoji/1f202-fe0f.png": 711011,
	"./emoji/1f21a-fe0f.png": 845319,
	"./emoji/1f22f-fe0f.png": 513853,
	"./emoji/1f232.png": 108134,
	"./emoji/1f233.png": 147151,
	"./emoji/1f234.png": 704304,
	"./emoji/1f235.png": 301209,
	"./emoji/1f236.png": 753026,
	"./emoji/1f237-fe0f.png": 265907,
	"./emoji/1f238.png": 370556,
	"./emoji/1f239.png": 899973,
	"./emoji/1f23a.png": 156237,
	"./emoji/1f250.png": 30034,
	"./emoji/1f251.png": 444251,
	"./emoji/1f300.png": 727560,
	"./emoji/1f301.png": 967505,
	"./emoji/1f302.png": 842842,
	"./emoji/1f303.png": 64419,
	"./emoji/1f304.png": 134252,
	"./emoji/1f305.png": 217141,
	"./emoji/1f306.png": 131390,
	"./emoji/1f307.png": 2727,
	"./emoji/1f308.png": 859104,
	"./emoji/1f309.png": 830281,
	"./emoji/1f30a.png": 383937,
	"./emoji/1f30b.png": 226506,
	"./emoji/1f30c.png": 958419,
	"./emoji/1f30d.png": 61020,
	"./emoji/1f30e.png": 813285,
	"./emoji/1f30f.png": 585454,
	"./emoji/1f310.png": 986739,
	"./emoji/1f311.png": 347882,
	"./emoji/1f312.png": 296865,
	"./emoji/1f313.png": 812248,
	"./emoji/1f314.png": 603767,
	"./emoji/1f315.png": 944398,
	"./emoji/1f316.png": 332549,
	"./emoji/1f317.png": 803132,
	"./emoji/1f318.png": 406731,
	"./emoji/1f319.png": 185602,
	"./emoji/1f31a.png": 819578,
	"./emoji/1f31b.png": 995825,
	"./emoji/1f31c.png": 547432,
	"./emoji/1f31d.png": 127047,
	"./emoji/1f31e.png": 951262,
	"./emoji/1f31f.png": 787989,
	"./emoji/1f320.png": 258754,
	"./emoji/1f321.png": 22411,
	"./emoji/1f324.png": 884134,
	"./emoji/1f325.png": 652879,
	"./emoji/1f326.png": 730420,
	"./emoji/1f327.png": 951549,
	"./emoji/1f328.png": 174954,
	"./emoji/1f329.png": 25715,
	"./emoji/1f32a.png": 234075,
	"./emoji/1f32b.png": 455744,
	"./emoji/1f32c.png": 426921,
	"./emoji/1f32d.png": 810742,
	"./emoji/1f32e.png": 407071,
	"./emoji/1f32f.png": 452420,
	"./emoji/1f330.png": 841229,
	"./emoji/1f331.png": 177988,
	"./emoji/1f332.png": 463263,
	"./emoji/1f333.png": 409462,
	"./emoji/1f334.png": 59433,
	"./emoji/1f335.png": 935232,
	"./emoji/1f336.png": 832795,
	"./emoji/1f337.png": 511250,
	"./emoji/1f338.png": 40405,
	"./emoji/1f339.png": 128780,
	"./emoji/1f33a.png": 613236,
	"./emoji/1f33b.png": 832143,
	"./emoji/1f33c.png": 793126,
	"./emoji/1f33d.png": 986201,
	"./emoji/1f33e.png": 905648,
	"./emoji/1f33f.png": 659147,
	"./emoji/1f340.png": 429540,
	"./emoji/1f341.png": 683437,
	"./emoji/1f342.png": 869462,
	"./emoji/1f343.png": 766399,
	"./emoji/1f344.png": 331424,
	"./emoji/1f345.png": 209545,
	"./emoji/1f346.png": 878578,
	"./emoji/1f347.png": 593403,
	"./emoji/1f348.png": 513516,
	"./emoji/1f349.png": 265781,
	"./emoji/1f34a.png": 928669,
	"./emoji/1f34b.png": 147462,
	"./emoji/1f34c.png": 186479,
	"./emoji/1f34d.png": 74256,
	"./emoji/1f34e.png": 80505,
	"./emoji/1f34f.png": 740770,
	"./emoji/1f350.png": 662543,
	"./emoji/1f351.png": 377446,
	"./emoji/1f352.png": 961213,
	"./emoji/1f353.png": 740084,
	"./emoji/1f354.png": 32075,
	"./emoji/1f355.png": 268418,
	"./emoji/1f356.png": 782425,
	"./emoji/1f357.png": 66672,
	"./emoji/1f358.png": 440503,
	"./emoji/1f359.png": 450510,
	"./emoji/1f35a.png": 820406,
	"./emoji/1f35b.png": 702029,
	"./emoji/1f35c.png": 462084,
	"./emoji/1f35d.png": 243739,
	"./emoji/1f35e.png": 829522,
	"./emoji/1f35f.png": 436585,
	"./emoji/1f360.png": 834078,
	"./emoji/1f361.png": 552391,
	"./emoji/1f362.png": 632332,
	"./emoji/1f363.png": 1429,
	"./emoji/1f364.png": 244922,
	"./emoji/1f365.png": 562499,
	"./emoji/1f366.png": 277224,
	"./emoji/1f367.png": 175089,
	"./emoji/1f368.png": 463158,
	"./emoji/1f369.png": 59487,
	"./emoji/1f36a.png": 83255,
	"./emoji/1f36b.png": 494524,
	"./emoji/1f36c.png": 812037,
	"./emoji/1f36d.png": 827370,
	"./emoji/1f36e.png": 678131,
	"./emoji/1f36f.png": 503640,
	"./emoji/1f370.png": 58489,
	"./emoji/1f371.png": 52240,
	"./emoji/1f372.png": 482411,
	"./emoji/1f373.png": 591906,
	"./emoji/1f374.png": 753629,
	"./emoji/1f375.png": 16148,
	"./emoji/1f376.png": 37615,
	"./emoji/1f377.png": 233689,
	"./emoji/1f378.png": 583937,
	"./emoji/1f379.png": 362808,
	"./emoji/1f37a.png": 59104,
	"./emoji/1f37b.png": 414139,
	"./emoji/1f37c.png": 665138,
	"./emoji/1f37d.png": 46701,
	"./emoji/1f37e.png": 4196,
	"./emoji/1f37f.png": 434111,
	"./emoji/1f380.png": 925568,
	"./emoji/1f381.png": 49769,
	"./emoji/1f382.png": 501586,
	"./emoji/1f383.png": 823131,
	"./emoji/1f384.png": 168324,
	"./emoji/1f385-1f3fb.png": 774842,
	"./emoji/1f385-1f3fc.png": 364675,
	"./emoji/1f385-1f3fd.png": 315276,
	"./emoji/1f385-1f3fe.png": 226901,
	"./emoji/1f385-1f3ff.png": 390174,
	"./emoji/1f385.png": 831565,
	"./emoji/1f386.png": 399798,
	"./emoji/1f387.png": 453599,
	"./emoji/1f388.png": 306536,
	"./emoji/1f389.png": 238577,
	"./emoji/1f38a.png": 976537,
	"./emoji/1f38b.png": 428354,
	"./emoji/1f38c.png": 649483,
	"./emoji/1f38d.png": 603572,
	"./emoji/1f38e.png": 824701,
	"./emoji/1f38f.png": 783462,
	"./emoji/1f390.png": 299819,
	"./emoji/1f391.png": 78690,
	"./emoji/1f392.png": 418425,
	"./emoji/1f393.png": 928528,
	"./emoji/1f396.png": 266589,
	"./emoji/1f397.png": 349908,
	"./emoji/1f399.png": 489994,
	"./emoji/1f39a.png": 216498,
	"./emoji/1f39b.png": 547465,
	"./emoji/1f39e.png": 207382,
	"./emoji/1f39f.png": 21357,
	"./emoji/1f3a0.png": 901603,
	"./emoji/1f3a1.png": 680026,
	"./emoji/1f3a2.png": 804689,
	"./emoji/1f3a3.png": 564744,
	"./emoji/1f3a4.png": 839911,
	"./emoji/1f3a5.png": 968574,
	"./emoji/1f3a6.png": 54325,
	"./emoji/1f3a7.png": 971436,
	"./emoji/1f3a8.png": 51323,
	"./emoji/1f3a9.png": 302322,
	"./emoji/1f3aa.png": 580042,
	"./emoji/1f3ab.png": 221121,
	"./emoji/1f3ac.png": 999992,
	"./emoji/1f3ad.png": 122135,
	"./emoji/1f3ae.png": 422638,
	"./emoji/1f3af.png": 650469,
	"./emoji/1f3b0.png": 706098,
	"./emoji/1f3b1.png": 937275,
	"./emoji/1f3b2.png": 158944,
	"./emoji/1f3b3.png": 37065,
	"./emoji/1f3b4.png": 696982,
	"./emoji/1f3b5.png": 110271,
	"./emoji/1f3b6.png": 257060,
	"./emoji/1f3b7.png": 510957,
	"./emoji/1f3b8.png": 753178,
	"./emoji/1f3b9.png": 517283,
	"./emoji/1f3ba.png": 789419,
	"./emoji/1f3bb.png": 418128,
	"./emoji/1f3bc.png": 908025,
	"./emoji/1f3bd.png": 974982,
	"./emoji/1f3be.png": 13999,
	"./emoji/1f3bf.png": 839508,
	"./emoji/1f3c0.png": 788733,
	"./emoji/1f3c1.png": 567604,
	"./emoji/1f3c2.png": 490063,
	"./emoji/1f3c3-1f3fb-200d-2640-fe0f.png": 986857,
	"./emoji/1f3c3-1f3fb.png": 689585,
	"./emoji/1f3c3-1f3fc-200d-2640-fe0f.png": 480106,
	"./emoji/1f3c3-1f3fc.png": 791720,
	"./emoji/1f3c3-1f3fd-200d-2640-fe0f.png": 477671,
	"./emoji/1f3c3-1f3fd.png": 66887,
	"./emoji/1f3c3-1f3fe-200d-2640-fe0f.png": 912200,
	"./emoji/1f3c3-1f3fe.png": 348574,
	"./emoji/1f3c3-1f3ff-200d-2640-fe0f.png": 50285,
	"./emoji/1f3c3-1f3ff.png": 515925,
	"./emoji/1f3c3-200d-2640-fe0f.png": 739280,
	"./emoji/1f3c3.png": 721318,
	"./emoji/1f3c4-1f3fb-200d-2640-fe0f.png": 115560,
	"./emoji/1f3c4-1f3fb.png": 845502,
	"./emoji/1f3c4-1f3fc-200d-2640-fe0f.png": 191111,
	"./emoji/1f3c4-1f3fc.png": 716839,
	"./emoji/1f3c4-1f3fd-200d-2640-fe0f.png": 788426,
	"./emoji/1f3c4-1f3fd.png": 441672,
	"./emoji/1f3c4-1f3fe-200d-2640-fe0f.png": 527241,
	"./emoji/1f3c4-1f3fe.png": 681617,
	"./emoji/1f3c4-1f3ff-200d-2640-fe0f.png": 584756,
	"./emoji/1f3c4-1f3ff.png": 556954,
	"./emoji/1f3c4-200d-2640-fe0f.png": 84305,
	"./emoji/1f3c4.png": 609945,
	"./emoji/1f3c5.png": 894192,
	"./emoji/1f3c6.png": 859595,
	"./emoji/1f3c7-1f3fb.png": 828165,
	"./emoji/1f3c7-1f3fc.png": 510652,
	"./emoji/1f3c7-1f3fd.png": 694259,
	"./emoji/1f3c7-1f3fe.png": 843498,
	"./emoji/1f3c7-1f3ff.png": 792481,
	"./emoji/1f3c7.png": 95938,
	"./emoji/1f3c8.png": 996805,
	"./emoji/1f3c9.png": 679292,
	"./emoji/1f3ca-1f3fb-200d-2640-fe0f.png": 760415,
	"./emoji/1f3ca-1f3fb.png": 481791,
	"./emoji/1f3ca-1f3fc-200d-2640-fe0f.png": 194912,
	"./emoji/1f3ca-1f3fc.png": 703702,
	"./emoji/1f3ca-1f3fd-200d-2640-fe0f.png": 631841,
	"./emoji/1f3ca-1f3fd.png": 77961,
	"./emoji/1f3ca-1f3fe-200d-2640-fe0f.png": 688194,
	"./emoji/1f3ca-1f3fe.png": 623136,
	"./emoji/1f3ca-1f3ff-200d-2640-fe0f.png": 952315,
	"./emoji/1f3ca-1f3ff.png": 978171,
	"./emoji/1f3ca-200d-2640-fe0f.png": 850630,
	"./emoji/1f3ca.png": 289604,
	"./emoji/1f3cb-1f3fb-200d-2640-fe0f.png": 481126,
	"./emoji/1f3cb-1f3fb.png": 465828,
	"./emoji/1f3cb-1f3fc-200d-2640-fe0f.png": 899653,
	"./emoji/1f3cb-1f3fc.png": 508333,
	"./emoji/1f3cb-1f3fd-200d-2640-fe0f.png": 520140,
	"./emoji/1f3cb-1f3fd.png": 126770,
	"./emoji/1f3cb-1f3fe-200d-2640-fe0f.png": 864955,
	"./emoji/1f3cb-1f3fe.png": 875771,
	"./emoji/1f3cb-1f3ff-200d-2640-fe0f.png": 600834,
	"./emoji/1f3cb-1f3ff.png": 520736,
	"./emoji/1f3cb-fe0f-200d-2640-fe0f.png": 756863,
	"./emoji/1f3cb-fe0f.png": 859551,
	"./emoji/1f3cc-1f3fb-200d-2640-fe0f.png": 132761,
	"./emoji/1f3cc-1f3fb.png": 164673,
	"./emoji/1f3cc-1f3fc-200d-2640-fe0f.png": 247962,
	"./emoji/1f3cc-1f3fc.png": 943544,
	"./emoji/1f3cc-1f3fd-200d-2640-fe0f.png": 193303,
	"./emoji/1f3cc-1f3fd.png": 192535,
	"./emoji/1f3cc-1f3fe-200d-2640-fe0f.png": 780792,
	"./emoji/1f3cc-1f3fe.png": 246958,
	"./emoji/1f3cc-1f3ff-200d-2640-fe0f.png": 843677,
	"./emoji/1f3cc-1f3ff.png": 17317,
	"./emoji/1f3cc-fe0f-200d-2640-fe0f.png": 148298,
	"./emoji/1f3cc-fe0f.png": 888712,
	"./emoji/1f3cd.png": 264105,
	"./emoji/1f3ce.png": 292928,
	"./emoji/1f3cf.png": 71259,
	"./emoji/1f3d0.png": 369684,
	"./emoji/1f3d1.png": 590813,
	"./emoji/1f3d2.png": 293254,
	"./emoji/1f3d3.png": 874799,
	"./emoji/1f3d4.png": 405776,
	"./emoji/1f3d5.png": 412025,
	"./emoji/1f3d6.png": 429090,
	"./emoji/1f3d7.png": 319595,
	"./emoji/1f3d8.png": 98204,
	"./emoji/1f3d9.png": 334117,
	"./emoji/1f3da.png": 883885,
	"./emoji/1f3db.png": 493206,
	"./emoji/1f3dc.png": 271295,
	"./emoji/1f3dd.png": 896288,
	"./emoji/1f3de.png": 867465,
	"./emoji/1f3df.png": 502322,
	"./emoji/1f3e0.png": 119935,
	"./emoji/1f3e1.png": 706646,
	"./emoji/1f3e2.png": 520621,
	"./emoji/1f3e3.png": 266724,
	"./emoji/1f3e4.png": 946939,
	"./emoji/1f3e5.png": 715762,
	"./emoji/1f3e6.png": 46729,
	"./emoji/1f3e7.png": 168608,
	"./emoji/1f3e8.png": 769703,
	"./emoji/1f3e9.png": 500862,
	"./emoji/1f3ea.png": 984646,
	"./emoji/1f3eb.png": 765853,
	"./emoji/1f3ec.png": 849172,
	"./emoji/1f3ed.png": 799083,
	"./emoji/1f3ee.png": 577954,
	"./emoji/1f3ef.png": 917689,
	"./emoji/1f3f0.png": 297934,
	"./emoji/1f3f3-fe0f-200d-1f308.png": 691497,
	"./emoji/1f3f3-fe0f.png": 599553,
	"./emoji/1f3f4.png": 185066,
	"./emoji/1f3f5.png": 823923,
	"./emoji/1f3f7.png": 134049,
	"./emoji/1f3f8.png": 377894,
	"./emoji/1f3f9.png": 416911,
	"./emoji/1f3fa.png": 964231,
	"./emoji/1f400.png": 524431,
	"./emoji/1f401.png": 239334,
	"./emoji/1f402.png": 823101,
	"./emoji/1f403.png": 601972,
	"./emoji/1f404.png": 893963,
	"./emoji/1f405.png": 130306,
	"./emoji/1f406.png": 644313,
	"./emoji/1f407.png": 928560,
	"./emoji/1f408.png": 302391,
	"./emoji/1f409.png": 312398,
	"./emoji/1f40a.png": 682294,
	"./emoji/1f40b.png": 563917,
	"./emoji/1f40c.png": 323972,
	"./emoji/1f40d.png": 105627,
	"./emoji/1f40e.png": 691410,
	"./emoji/1f40f.png": 782121,
	"./emoji/1f410.png": 291428,
	"./emoji/1f411.png": 545325,
	"./emoji/1f412.png": 731350,
	"./emoji/1f413.png": 628287,
	"./emoji/1f414.png": 193312,
	"./emoji/1f415.png": 71433,
	"./emoji/1f416.png": 740466,
	"./emoji/1f417.png": 455291,
	"./emoji/1f418.png": 375404,
	"./emoji/1f419.png": 611317,
	"./emoji/1f41a.png": 790557,
	"./emoji/1f41b.png": 9350,
	"./emoji/1f41c.png": 48367,
	"./emoji/1f41d.png": 936144,
	"./emoji/1f41e.png": 942393,
	"./emoji/1f41f.png": 602658,
	"./emoji/1f420.png": 920377,
	"./emoji/1f421.png": 914128,
	"./emoji/1f422.png": 344299,
	"./emoji/1f423.png": 453794,
	"./emoji/1f424.png": 615517,
	"./emoji/1f425.png": 878036,
	"./emoji/1f426.png": 899503,
	"./emoji/1f427.png": 317958,
	"./emoji/1f428.png": 445825,
	"./emoji/1f429.png": 224696,
	"./emoji/1f42a.png": 920992,
	"./emoji/1f42b.png": 276027,
	"./emoji/1f42c.png": 527026,
	"./emoji/1f42d.png": 908589,
	"./emoji/1f42e.png": 866084,
	"./emoji/1f42f.png": 779647,
	"./emoji/1f430.png": 695966,
	"./emoji/1f431.png": 414279,
	"./emoji/1f432.png": 494220,
	"./emoji/1f433.png": 863317,
	"./emoji/1f434.png": 106810,
	"./emoji/1f435.png": 424387,
	"./emoji/1f436.png": 139112,
	"./emoji/1f437.png": 36977,
	"./emoji/1f438.png": 325046,
	"./emoji/1f439.png": 921375,
	"./emoji/1f43a.png": 945143,
	"./emoji/1f43b.png": 356412,
	"./emoji/1f43c.png": 673925,
	"./emoji/1f43d.png": 689258,
	"./emoji/1f43e.png": 540019,
	"./emoji/1f43f.png": 365528,
	"./emoji/1f440.png": 848627,
	"./emoji/1f441-200d-1f5e8.png": 348829,
	"./emoji/1f441.png": 209770,
	"./emoji/1f442-1f3fb.png": 346582,
	"./emoji/1f442-1f3fc.png": 243519,
	"./emoji/1f442-1f3fd.png": 292192,
	"./emoji/1f442-1f3fe.png": 170313,
	"./emoji/1f442-1f3ff.png": 355698,
	"./emoji/1f442.png": 158753,
	"./emoji/1f443-1f3fb.png": 101627,
	"./emoji/1f443-1f3fc.png": 386802,
	"./emoji/1f443-1f3fd.png": 191661,
	"./emoji/1f443-1f3fe.png": 937764,
	"./emoji/1f443-1f3ff.png": 274623,
	"./emoji/1f443.png": 674136,
	"./emoji/1f444.png": 465655,
	"./emoji/1f445.png": 806286,
	"./emoji/1f446-1f3fb.png": 306722,
	"./emoji/1f446-1f3fc.png": 527851,
	"./emoji/1f446-1f3fd.png": 577940,
	"./emoji/1f446-1f3fe.png": 494621,
	"./emoji/1f446-1f3ff.png": 713414,
	"./emoji/1f446.png": 194437,
	"./emoji/1f447-1f3fb.png": 711527,
	"./emoji/1f447-1f3fc.png": 959038,
	"./emoji/1f447-1f3fd.png": 125777,
	"./emoji/1f447-1f3fe.png": 131912,
	"./emoji/1f447-1f3ff.png": 468771,
	"./emoji/1f447.png": 665020,
	"./emoji/1f448-1f3fb.png": 186728,
	"./emoji/1f448-1f3fc.png": 118769,
	"./emoji/1f448-1f3fd.png": 590558,
	"./emoji/1f448-1f3fe.png": 766343,
	"./emoji/1f448-1f3ff.png": 999308,
	"./emoji/1f448.png": 268619,
	"./emoji/1f449-1f3fb.png": 377413,
	"./emoji/1f449-1f3fc.png": 364348,
	"./emoji/1f449-1f3fd.png": 547955,
	"./emoji/1f449-1f3fe.png": 392746,
	"./emoji/1f449-1f3ff.png": 341729,
	"./emoji/1f449.png": 47490,
	"./emoji/1f44a-1f3fb.png": 963629,
	"./emoji/1f44a-1f3fc.png": 709732,
	"./emoji/1f44a-1f3fd.png": 873595,
	"./emoji/1f44a-1f3fe.png": 158770,
	"./emoji/1f44a-1f3ff.png": 489737,
	"./emoji/1f44a.png": 681466,
	"./emoji/1f44b-1f3fb.png": 445414,
	"./emoji/1f44b-1f3fc.png": 484431,
	"./emoji/1f44b-1f3fd.png": 41584,
	"./emoji/1f44b-1f3fe.png": 638489,
	"./emoji/1f44b-1f3ff.png": 573954,
	"./emoji/1f44b.png": 857713,
	"./emoji/1f44c-1f3fb.png": 234635,
	"./emoji/1f44c-1f3fc.png": 13506,
	"./emoji/1f44c-1f3fd.png": 409853,
	"./emoji/1f44c-1f3fe.png": 188724,
	"./emoji/1f44c-1f3ff.png": 923983,
	"./emoji/1f44c.png": 409320,
	"./emoji/1f44d-1f3fb.png": 883228,
	"./emoji/1f44d-1f3fc.png": 966117,
	"./emoji/1f44d-1f3fd.png": 599242,
	"./emoji/1f44d-1f3fe.png": 754451,
	"./emoji/1f44d-1f3ff.png": 892344,
	"./emoji/1f44d.png": 988935,
	"./emoji/1f44e-1f3fb.png": 311865,
	"./emoji/1f44e-1f3fc.png": 305616,
	"./emoji/1f44e-1f3fd.png": 290991,
	"./emoji/1f44e-1f3fe.png": 709446,
	"./emoji/1f44e-1f3ff.png": 490653,
	"./emoji/1f44e.png": 813150,
	"./emoji/1f44f-1f3fb.png": 318258,
	"./emoji/1f44f-1f3fc.png": 33083,
	"./emoji/1f44f-1f3fd.png": 869220,
	"./emoji/1f44f-1f3fe.png": 123117,
	"./emoji/1f44f-1f3ff.png": 309142,
	"./emoji/1f44f.png": 649877,
	"./emoji/1f450-1f3fb.png": 94763,
	"./emoji/1f450-1f3fc.png": 204258,
	"./emoji/1f450-1f3fd.png": 365981,
	"./emoji/1f450-1f3fe.png": 144852,
	"./emoji/1f450-1f3ff.png": 649967,
	"./emoji/1f450.png": 589448,
	"./emoji/1f451.png": 829393,
	"./emoji/1f452.png": 704730,
	"./emoji/1f453.png": 926307,
	"./emoji/1f454.png": 996140,
	"./emoji/1f455.png": 79029,
	"./emoji/1f456.png": 476926,
	"./emoji/1f457.png": 864615,
	"./emoji/1f458.png": 720992,
	"./emoji/1f459.png": 692169,
	"./emoji/1f45a.png": 245825,
	"./emoji/1f45b.png": 88394,
	"./emoji/1f45c.png": 820307,
	"./emoji/1f45d.png": 922908,
	"./emoji/1f45e.png": 158821,
	"./emoji/1f45f.png": 447342,
	"./emoji/1f460.png": 703117,
	"./emoji/1f461.png": 39876,
	"./emoji/1f462.png": 325151,
	"./emoji/1f463.png": 271350,
	"./emoji/1f464.png": 921321,
	"./emoji/1f465.png": 797120,
	"./emoji/1f466-1f3fb.png": 402872,
	"./emoji/1f466-1f3fc.png": 624001,
	"./emoji/1f466-1f3fd.png": 706286,
	"./emoji/1f466-1f3fe.png": 135511,
	"./emoji/1f466-1f3ff.png": 393756,
	"./emoji/1f466.png": 694683,
	"./emoji/1f467-1f3fb.png": 573653,
	"./emoji/1f467-1f3fc.png": 662028,
	"./emoji/1f467-1f3fd.png": 711427,
	"./emoji/1f467-1f3fe.png": 605242,
	"./emoji/1f467-1f3ff.png": 781489,
	"./emoji/1f467.png": 373138,
	"./emoji/1f468-1f3fb.png": 637042,
	"./emoji/1f468-1f3fc.png": 351867,
	"./emoji/1f468-1f3fd.png": 671652,
	"./emoji/1f468-1f3fe.png": 441901,
	"./emoji/1f468-1f3ff.png": 111574,
	"./emoji/1f468-200d-1f33e.png": 678677,
	"./emoji/1f468-200d-1f373.png": 553231,
	"./emoji/1f468-200d-1f393.png": 4961,
	"./emoji/1f468-200d-1f3a4.png": 548550,
	"./emoji/1f468-200d-1f3a8.png": 553162,
	"./emoji/1f468-200d-1f3eb.png": 489564,
	"./emoji/1f468-200d-1f3ed.png": 205578,
	"./emoji/1f468-200d-1f466-200d-1f466.png": 851155,
	"./emoji/1f468-200d-1f466.png": 903914,
	"./emoji/1f468-200d-1f467-200d-1f466.png": 819404,
	"./emoji/1f468-200d-1f467-200d-1f467.png": 731029,
	"./emoji/1f468-200d-1f467.png": 754675,
	"./emoji/1f468-200d-1f468-200d-1f466-200d-1f466.png": 334294,
	"./emoji/1f468-200d-1f468-200d-1f466.png": 683521,
	"./emoji/1f468-200d-1f468-200d-1f467-200d-1f466.png": 439781,
	"./emoji/1f468-200d-1f468-200d-1f467-200d-1f467.png": 203868,
	"./emoji/1f468-200d-1f468-200d-1f467.png": 462392,
	"./emoji/1f468-200d-1f469-200d-1f466-200d-1f466.png": 320379,
	"./emoji/1f468-200d-1f469-200d-1f467-200d-1f466.png": 528212,
	"./emoji/1f468-200d-1f469-200d-1f467-200d-1f467.png": 749341,
	"./emoji/1f468-200d-1f469-200d-1f467.png": 831819,
	"./emoji/1f468-200d-1f4bb.png": 782642,
	"./emoji/1f468-200d-1f4bc.png": 13819,
	"./emoji/1f468-200d-1f527.png": 124250,
	"./emoji/1f468-200d-1f52c.png": 947182,
	"./emoji/1f468-200d-1f680.png": 202736,
	"./emoji/1f468-200d-1f692.png": 628841,
	"./emoji/1f468-200d-2695-fe0f.png": 900823,
	"./emoji/1f468-200d-2696-fe0f.png": 658554,
	"./emoji/1f468-200d-2708-fe0f.png": 494706,
	"./emoji/1f468-200d-2764-fe0f-200d-1f468.png": 519331,
	"./emoji/1f468-200d-2764-fe0f-200d-1f48b-200d-1f468.png": 62442,
	"./emoji/1f468.png": 902293,
	"./emoji/1f469-1f3fb.png": 728567,
	"./emoji/1f469-1f3fc.png": 585550,
	"./emoji/1f469-1f3fd.png": 421665,
	"./emoji/1f469-1f3fe.png": 453400,
	"./emoji/1f469-1f3ff.png": 627891,
	"./emoji/1f469-200d-1f33e.png": 714262,
	"./emoji/1f469-200d-1f373.png": 10732,
	"./emoji/1f469-200d-1f393.png": 916342,
	"./emoji/1f469-200d-1f3a4.png": 671505,
	"./emoji/1f469-200d-1f3a8.png": 8173,
	"./emoji/1f469-200d-1f3eb.png": 260163,
	"./emoji/1f469-200d-1f3ed.png": 122389,
	"./emoji/1f469-200d-1f466-200d-1f466.png": 578830,
	"./emoji/1f469-200d-1f466.png": 878153,
	"./emoji/1f469-200d-1f467-200d-1f466.png": 549917,
	"./emoji/1f469-200d-1f467-200d-1f467.png": 116884,
	"./emoji/1f469-200d-1f467.png": 483680,
	"./emoji/1f469-200d-1f469-200d-1f466-200d-1f466.png": 61872,
	"./emoji/1f469-200d-1f469-200d-1f466.png": 847751,
	"./emoji/1f469-200d-1f469-200d-1f467-200d-1f466.png": 823975,
	"./emoji/1f469-200d-1f469-200d-1f467-200d-1f467.png": 952638,
	"./emoji/1f469-200d-1f469-200d-1f467.png": 671966,
	"./emoji/1f469-200d-1f4bb.png": 827249,
	"./emoji/1f469-200d-1f4bc.png": 378856,
	"./emoji/1f469-200d-1f527.png": 185385,
	"./emoji/1f469-200d-1f52c.png": 226365,
	"./emoji/1f469-200d-1f680.png": 772215,
	"./emoji/1f469-200d-1f692.png": 995390,
	"./emoji/1f469-200d-2695-fe0f.png": 671908,
	"./emoji/1f469-200d-2696-fe0f.png": 396165,
	"./emoji/1f469-200d-2708-fe0f.png": 239305,
	"./emoji/1f469-200d-2764-fe0f-200d-1f469.png": 124771,
	"./emoji/1f469-200d-2764-fe0f-200d-1f48b-200d-1f469.png": 610832,
	"./emoji/1f469.png": 990668,
	"./emoji/1f46a.png": 475124,
	"./emoji/1f46b.png": 694031,
	"./emoji/1f46c.png": 655014,
	"./emoji/1f46d.png": 848089,
	"./emoji/1f46e-1f3fb-200d-2640-fe0f.png": 881795,
	"./emoji/1f46e-1f3fb.png": 537507,
	"./emoji/1f46e-1f3fc-200d-2640-fe0f.png": 562868,
	"./emoji/1f46e-1f3fc.png": 773402,
	"./emoji/1f46e-1f3fd-200d-2640-fe0f.png": 25293,
	"./emoji/1f46e-1f3fd.png": 113525,
	"./emoji/1f46e-1f3fe-200d-2640-fe0f.png": 103758,
	"./emoji/1f46e-1f3fe.png": 361260,
	"./emoji/1f46e-1f3ff-200d-2640-fe0f.png": 589127,
	"./emoji/1f46e-1f3ff.png": 780263,
	"./emoji/1f46e-200d-2640-fe0f.png": 84018,
	"./emoji/1f46e.png": 767536,
	"./emoji/1f46f-200d-2642-fe0f.png": 457269,
	"./emoji/1f46f.png": 521035,
	"./emoji/1f470-1f3fb.png": 982405,
	"./emoji/1f470-1f3fc.png": 664892,
	"./emoji/1f470-1f3fd.png": 848499,
	"./emoji/1f470-1f3fe.png": 997738,
	"./emoji/1f470-1f3ff.png": 946721,
	"./emoji/1f470.png": 120642,
	"./emoji/1f471-1f3fb-200d-2640-fe0f.png": 716394,
	"./emoji/1f471-1f3fb.png": 803944,
	"./emoji/1f471-1f3fc-200d-2640-fe0f.png": 223145,
	"./emoji/1f471-1f3fc.png": 701809,
	"./emoji/1f471-1f3fd-200d-2640-fe0f.png": 148488,
	"./emoji/1f471-1f3fd.png": 360798,
	"./emoji/1f471-1f3fe-200d-2640-fe0f.png": 197607,
	"./emoji/1f471-1f3fe.png": 79111,
	"./emoji/1f471-1f3ff-200d-2640-fe0f.png": 414254,
	"./emoji/1f471-1f3ff.png": 159052,
	"./emoji/1f471-200d-2640-fe0f.png": 128043,
	"./emoji/1f471.png": 884299,
	"./emoji/1f472-1f3fb.png": 823715,
	"./emoji/1f472-1f3fc.png": 118490,
	"./emoji/1f472-1f3fd.png": 976437,
	"./emoji/1f472-1f3fe.png": 893548,
	"./emoji/1f472-1f3ff.png": 762023,
	"./emoji/1f472.png": 918896,
	"./emoji/1f473-1f3fb-200d-2640-fe0f.png": 165992,
	"./emoji/1f473-1f3fb.png": 999742,
	"./emoji/1f473-1f3fc-200d-2640-fe0f.png": 241543,
	"./emoji/1f473-1f3fc.png": 871079,
	"./emoji/1f473-1f3fd-200d-2640-fe0f.png": 838858,
	"./emoji/1f473-1f3fd.png": 595912,
	"./emoji/1f473-1f3fe-200d-2640-fe0f.png": 577673,
	"./emoji/1f473-1f3fe.png": 835857,
	"./emoji/1f473-1f3ff-200d-2640-fe0f.png": 635188,
	"./emoji/1f473-1f3ff.png": 711194,
	"./emoji/1f473-200d-2640-fe0f.png": 724049,
	"./emoji/1f473.png": 634649,
	"./emoji/1f474-1f3fb.png": 843825,
	"./emoji/1f474-1f3fc.png": 945960,
	"./emoji/1f474-1f3fd.png": 221127,
	"./emoji/1f474-1f3fe.png": 502814,
	"./emoji/1f474-1f3ff.png": 670165,
	"./emoji/1f474.png": 229670,
	"./emoji/1f475-1f3fb.png": 219156,
	"./emoji/1f475-1f3fc.png": 440285,
	"./emoji/1f475-1f3fd.png": 278562,
	"./emoji/1f475-1f3fe.png": 169067,
	"./emoji/1f475-1f3ff.png": 255248,
	"./emoji/1f475.png": 514767,
	"./emoji/1f476-1f3fb.png": 670255,
	"./emoji/1f476-1f3fc.png": 631238,
	"./emoji/1f476-1f3fd.png": 564281,
	"./emoji/1f476-1f3fe.png": 558032,
	"./emoji/1f476-1f3ff.png": 445675,
	"./emoji/1f476.png": 592308,
	"./emoji/1f477-1f3fb-200d-2640-fe0f.png": 603044,
	"./emoji/1f477-1f3fb.png": 619882,
	"./emoji/1f477-1f3fc-200d-2640-fe0f.png": 181939,
	"./emoji/1f477-1f3fc.png": 775091,
	"./emoji/1f477-1f3fd-200d-2640-fe0f.png": 12798,
	"./emoji/1f477-1f3fd.png": 591484,
	"./emoji/1f477-1f3fe-200d-2640-fe0f.png": 901501,
	"./emoji/1f477-1f3fe.png": 604549,
	"./emoji/1f477-1f3ff-200d-2640-fe0f.png": 586136,
	"./emoji/1f477-1f3ff.png": 732750,
	"./emoji/1f477-200d-2640-fe0f.png": 848181,
	"./emoji/1f477.png": 813437,
	"./emoji/1f478-1f3fb.png": 452445,
	"./emoji/1f478-1f3fc.png": 535764,
	"./emoji/1f478-1f3fd.png": 485675,
	"./emoji/1f478-1f3fe.png": 264546,
	"./emoji/1f478-1f3ff.png": 604281,
	"./emoji/1f478.png": 36842,
	"./emoji/1f479.png": 887603,
	"./emoji/1f47a.png": 95963,
	"./emoji/1f47b.png": 317632,
	"./emoji/1f47c-1f3fb.png": 897038,
	"./emoji/1f47c-1f3fc.png": 370679,
	"./emoji/1f47c-1f3fd.png": 791064,
	"./emoji/1f47c-1f3fe.png": 63777,
	"./emoji/1f47c-1f3ff.png": 114794,
	"./emoji/1f47c.png": 772457,
	"./emoji/1f47d.png": 672630,
	"./emoji/1f47e.png": 268959,
	"./emoji/1f47f.png": 314308,
	"./emoji/1f480.png": 268391,
	"./emoji/1f481-1f3fb-200d-2640-fe0f.png": 974033,
	"./emoji/1f481-1f3fb-200d-2642-fe0f.png": 611431,
	"./emoji/1f481-1f3fb.png": 264025,
	"./emoji/1f481-1f3fc-200d-2640-fe0f.png": 932274,
	"./emoji/1f481-1f3fc-200d-2642-fe0f.png": 997144,
	"./emoji/1f481-1f3fc.png": 667120,
	"./emoji/1f481-1f3fd-200d-2640-fe0f.png": 48719,
	"./emoji/1f481-1f3fd-200d-2642-fe0f.png": 199321,
	"./emoji/1f481-1f3fd.png": 109967,
	"./emoji/1f481-1f3fe-200d-2640-fe0f.png": 64528,
	"./emoji/1f481-1f3fe-200d-2642-fe0f.png": 805450,
	"./emoji/1f481-1f3fe.png": 70950,
	"./emoji/1f481-1f3ff-200d-2640-fe0f.png": 174133,
	"./emoji/1f481-1f3ff-200d-2642-fe0f.png": 224683,
	"./emoji/1f481-1f3ff.png": 112189,
	"./emoji/1f481-200d-2642-fe0f.png": 359810,
	"./emoji/1f481.png": 515902,
	"./emoji/1f482-1f3fb-200d-2640-fe0f.png": 212652,
	"./emoji/1f482-1f3fb.png": 912530,
	"./emoji/1f482-1f3fc-200d-2640-fe0f.png": 98075,
	"./emoji/1f482-1f3fc.png": 326747,
	"./emoji/1f482-1f3fd-200d-2640-fe0f.png": 847046,
	"./emoji/1f482-1f3fd.png": 545092,
	"./emoji/1f482-1f3fe-200d-2640-fe0f.png": 615973,
	"./emoji/1f482-1f3fe.png": 785037,
	"./emoji/1f482-1f3ff-200d-2640-fe0f.png": 184448,
	"./emoji/1f482-1f3ff.png": 903414,
	"./emoji/1f482-200d-2640-fe0f.png": 993869,
	"./emoji/1f482.png": 601653,
	"./emoji/1f483-1f3fb.png": 547671,
	"./emoji/1f483-1f3fc.png": 602094,
	"./emoji/1f483-1f3fd.png": 519809,
	"./emoji/1f483-1f3fe.png": 298680,
	"./emoji/1f483-1f3ff.png": 644435,
	"./emoji/1f483.png": 365740,
	"./emoji/1f484.png": 541987,
	"./emoji/1f485-1f3fb.png": 954061,
	"./emoji/1f485-1f3fc.png": 714116,
	"./emoji/1f485-1f3fd.png": 979419,
	"./emoji/1f485-1f3fe.png": 81554,
	"./emoji/1f485-1f3ff.png": 172265,
	"./emoji/1f485.png": 777882,
	"./emoji/1f486-1f3fb-200d-2640-fe0f.png": 869360,
	"./emoji/1f486-1f3fb-200d-2642-fe0f.png": 711530,
	"./emoji/1f486-1f3fb.png": 790662,
	"./emoji/1f486-1f3fc-200d-2640-fe0f.png": 193583,
	"./emoji/1f486-1f3fc-200d-2642-fe0f.png": 711225,
	"./emoji/1f486-1f3fc.png": 829679,
	"./emoji/1f486-1f3fd-200d-2640-fe0f.png": 815506,
	"./emoji/1f486-1f3fd-200d-2642-fe0f.png": 440,
	"./emoji/1f486-1f3fd.png": 717456,
	"./emoji/1f486-1f3fe-200d-2640-fe0f.png": 390065,
	"./emoji/1f486-1f3fe-200d-2642-fe0f.png": 35015,
	"./emoji/1f486-1f3fe.png": 723705,
	"./emoji/1f486-1f3ff-200d-2640-fe0f.png": 419036,
	"./emoji/1f486-1f3ff-200d-2642-fe0f.png": 911206,
	"./emoji/1f486-1f3ff.png": 867618,
	"./emoji/1f486-200d-2642-fe0f.png": 707519,
	"./emoji/1f486.png": 198993,
	"./emoji/1f487-1f3fb-200d-2640-fe0f.png": 588427,
	"./emoji/1f487-1f3fb-200d-2642-fe0f.png": 278869,
	"./emoji/1f487-1f3fb.png": 699755,
	"./emoji/1f487-1f3fc-200d-2640-fe0f.png": 533596,
	"./emoji/1f487-1f3fc-200d-2642-fe0f.png": 542118,
	"./emoji/1f487-1f3fc.png": 478626,
	"./emoji/1f487-1f3fd-200d-2640-fe0f.png": 33941,
	"./emoji/1f487-1f3fd-200d-2642-fe0f.png": 859851,
	"./emoji/1f487-1f3fd.png": 666525,
	"./emoji/1f487-1f3fe-200d-2640-fe0f.png": 279478,
	"./emoji/1f487-1f3fe-200d-2642-fe0f.png": 475180,
	"./emoji/1f487-1f3fe.png": 749844,
	"./emoji/1f487-1f3ff-200d-2640-fe0f.png": 308143,
	"./emoji/1f487-1f3ff-200d-2642-fe0f.png": 342137,
	"./emoji/1f487-1f3ff.png": 924335,
	"./emoji/1f487-200d-2642-fe0f.png": 684368,
	"./emoji/1f487.png": 688776,
	"./emoji/1f488.png": 618623,
	"./emoji/1f489.png": 721686,
	"./emoji/1f48a.png": 117166,
	"./emoji/1f48b.png": 371173,
	"./emoji/1f48c.png": 288284,
	"./emoji/1f48d.png": 159507,
	"./emoji/1f48e.png": 4298,
	"./emoji/1f48f.png": 34881,
	"./emoji/1f490.png": 113244,
	"./emoji/1f491.png": 349157,
	"./emoji/1f492.png": 637678,
	"./emoji/1f493.png": 820823,
	"./emoji/1f494.png": 215032,
	"./emoji/1f495.png": 436161,
	"./emoji/1f496.png": 278730,
	"./emoji/1f497.png": 10643,
	"./emoji/1f498.png": 868372,
	"./emoji/1f499.png": 605853,
	"./emoji/1f49a.png": 269365,
	"./emoji/1f49b.png": 667262,
	"./emoji/1f49c.png": 54951,
	"./emoji/1f49d.png": 263432,
	"./emoji/1f49e.png": 19729,
	"./emoji/1f49f.png": 895066,
	"./emoji/1f4a0.png": 231572,
	"./emoji/1f4a1.png": 452701,
	"./emoji/1f4a2.png": 155142,
	"./emoji/1f4a3.png": 736687,
	"./emoji/1f4a4.png": 267664,
	"./emoji/1f4a5.png": 757561,
	"./emoji/1f4a6.png": 290978,
	"./emoji/1f4a7.png": 181483,
	"./emoji/1f4a8.png": 960092,
	"./emoji/1f4a9.png": 196005,
	"./emoji/1f4aa-1f3fb.png": 851802,
	"./emoji/1f4aa-1f3fc.png": 73379,
	"./emoji/1f4aa-1f3fd.png": 143212,
	"./emoji/1f4aa-1f3fe.png": 226101,
	"./emoji/1f4aa-1f3ff.png": 623998,
	"./emoji/1f4aa.png": 745773,
	"./emoji/1f4ab.png": 355094,
	"./emoji/1f4ac.png": 133183,
	"./emoji/1f4ad.png": 758176,
	"./emoji/1f4ae.png": 729353,
	"./emoji/1f4af.png": 364210,
	"./emoji/1f4b0.png": 262057,
	"./emoji/1f4b1.png": 807232,
	"./emoji/1f4b2.png": 585563,
	"./emoji/1f4b3.png": 171346,
	"./emoji/1f4b4.png": 43853,
	"./emoji/1f4b5.png": 803908,
	"./emoji/1f4b6.png": 758559,
	"./emoji/1f4b7.png": 162230,
	"./emoji/1f4b8.png": 874161,
	"./emoji/1f4b9.png": 976296,
	"./emoji/1f4ba.png": 408496,
	"./emoji/1f4bb.png": 373899,
	"./emoji/1f4bc.png": 610242,
	"./emoji/1f4bd.png": 303037,
	"./emoji/1f4be.png": 81908,
	"./emoji/1f4bf.png": 4367,
	"./emoji/1f4c0.png": 643470,
	"./emoji/1f4c1.png": 302839,
	"./emoji/1f4c2.png": 502204,
	"./emoji/1f4c3.png": 31621,
	"./emoji/1f4c4.png": 46954,
	"./emoji/1f4c5.png": 685811,
	"./emoji/1f4c6.png": 511320,
	"./emoji/1f4c7.png": 995937,
	"./emoji/1f4c8.png": 239782,
	"./emoji/1f4c9.png": 278799,
	"./emoji/1f4ca.png": 826119,
	"./emoji/1f4cb.png": 575436,
	"./emoji/1f4cc.png": 487061,
	"./emoji/1f4cd.png": 35002,
	"./emoji/1f4ce.png": 624835,
	"./emoji/1f4cf.png": 246504,
	"./emoji/1f4d0.png": 763491,
	"./emoji/1f4d1.png": 541914,
	"./emoji/1f4d2.png": 666577,
	"./emoji/1f4d3.png": 426632,
	"./emoji/1f4d4.png": 701799,
	"./emoji/1f4d5.png": 830462,
	"./emoji/1f4d6.png": 916213,
	"./emoji/1f4d7.png": 833324,
	"./emoji/1f4d8.png": 913211,
	"./emoji/1f4d9.png": 164210,
	"./emoji/1f4da.png": 925578,
	"./emoji/1f4db.png": 83009,
	"./emoji/1f4dc.png": 861880,
	"./emoji/1f4dd.png": 984023,
	"./emoji/1f4de.png": 284526,
	"./emoji/1f4df.png": 512357,
	"./emoji/1f4e0.png": 555768,
	"./emoji/1f4e1.png": 776897,
	"./emoji/1f4e2.png": 746314,
	"./emoji/1f4e3.png": 901523,
	"./emoji/1f4e4.png": 546652,
	"./emoji/1f4e5.png": 113189,
	"./emoji/1f4e6.png": 859182,
	"./emoji/1f4e7.png": 288407,
	"./emoji/1f4e8.png": 184848,
	"./emoji/1f4e9.png": 191097,
	"./emoji/1f4ea.png": 941009,
	"./emoji/1f4eb.png": 519898,
	"./emoji/1f4ec.png": 284003,
	"./emoji/1f4ed.png": 107756,
	"./emoji/1f4ee.png": 860021,
	"./emoji/1f4ef.png": 257918,
	"./emoji/1f4f0.png": 650621,
	"./emoji/1f4f1.png": 429492,
	"./emoji/1f4f2.png": 351951,
	"./emoji/1f4f3.png": 583206,
	"./emoji/1f4f4.png": 471833,
	"./emoji/1f4f5.png": 756080,
	"./emoji/1f4f6.png": 721483,
	"./emoji/1f4f7.png": 957826,
	"./emoji/1f4f8.png": 858693,
	"./emoji/1f4f9.png": 541180,
	"./emoji/1f4fa.png": 151492,
	"./emoji/1f4fb.png": 106143,
	"./emoji/1f4fc.png": 509814,
	"./emoji/1f4fd.png": 125993,
	"./emoji/1f4ff.png": 933147,
	"./emoji/1f500.png": 744974,
	"./emoji/1f501.png": 734967,
	"./emoji/1f502.png": 146236,
	"./emoji/1f503.png": 463749,
	"./emoji/1f504.png": 479082,
	"./emoji/1f505.png": 329843,
	"./emoji/1f506.png": 155352,
	"./emoji/1f507.png": 428065,
	"./emoji/1f508.png": 671910,
	"./emoji/1f509.png": 957007,
	"./emoji/1f50a.png": 204103,
	"./emoji/1f50b.png": 284044,
	"./emoji/1f50c.png": 653141,
	"./emoji/1f50d.png": 896634,
	"./emoji/1f50e.png": 214211,
	"./emoji/1f50f.png": 928936,
	"./emoji/1f510.png": 363561,
	"./emoji/1f511.png": 239360,
	"./emoji/1f512.png": 136923,
	"./emoji/1f513.png": 815378,
	"./emoji/1f514.png": 145357,
	"./emoji/1f515.png": 482116,
	"./emoji/1f516.png": 767391,
	"./emoji/1f517.png": 713590,
	"./emoji/1f518.png": 552369,
	"./emoji/1f519.png": 103976,
	"./emoji/1f51a.png": 693424,
	"./emoji/1f51b.png": 963275,
	"./emoji/1f51c.png": 742146,
	"./emoji/1f51d.png": 138493,
	"./emoji/1f51e.png": 917364,
	"./emoji/1f51f.png": 136271,
	"./emoji/1f520.png": 663700,
	"./emoji/1f521.png": 580381,
	"./emoji/1f522.png": 799174,
	"./emoji/1f523.png": 838191,
	"./emoji/1f524.png": 725968,
	"./emoji/1f525.png": 732217,
	"./emoji/1f526.png": 392482,
	"./emoji/1f527.png": 613611,
	"./emoji/1f528.png": 87772,
	"./emoji/1f529.png": 170661,
	"./emoji/1f52a.png": 335149,
	"./emoji/1f52b.png": 521174,
	"./emoji/1f52c.png": 418111,
	"./emoji/1f52d.png": 983136,
	"./emoji/1f52e.png": 861257,
	"./emoji/1f52f.png": 530290,
	"./emoji/1f530.png": 990655,
	"./emoji/1f531.png": 212566,
	"./emoji/1f532.png": 603245,
	"./emoji/1f533.png": 560740,
	"./emoji/1f534.png": 970683,
	"./emoji/1f535.png": 221682,
	"./emoji/1f536.png": 586825,
	"./emoji/1f537.png": 615648,
	"./emoji/1f538.png": 759271,
	"./emoji/1f539.png": 371582,
	"./emoji/1f53a.png": 12614,
	"./emoji/1f53b.png": 310173,
	"./emoji/1f53c.png": 89044,
	"./emoji/1f53d.png": 38955,
	"./emoji/1f549.png": 811299,
	"./emoji/1f54a.png": 29291,
	"./emoji/1f54b.png": 115472,
	"./emoji/1f54c.png": 605369,
	"./emoji/1f54d.png": 2950,
	"./emoji/1f54e.png": 584495,
	"./emoji/1f550.png": 328829,
	"./emoji/1f551.png": 107700,
	"./emoji/1f552.png": 326607,
	"./emoji/1f553.png": 287590,
	"./emoji/1f554.png": 480665,
	"./emoji/1f555.png": 883760,
	"./emoji/1f556.png": 153611,
	"./emoji/1f557.png": 932482,
	"./emoji/1f558.png": 563077,
	"./emoji/1f559.png": 550012,
	"./emoji/1f55a.png": 672452,
	"./emoji/1f55b.png": 957727,
	"./emoji/1f55c.png": 903926,
	"./emoji/1f55d.png": 553897,
	"./emoji/1f55e.png": 429696,
	"./emoji/1f55f.png": 327259,
	"./emoji/1f560.png": 657272,
	"./emoji/1f561.png": 878401,
	"./emoji/1f562.png": 720970,
	"./emoji/1f563.png": 452883,
	"./emoji/1f564.png": 555484,
	"./emoji/1f565.png": 791397,
	"./emoji/1f566.png": 563566,
	"./emoji/1f567.png": 263063,
	"./emoji/1f56f.png": 109502,
	"./emoji/1f570.png": 984227,
	"./emoji/1f573.png": 131016,
	"./emoji/1f574-1f3fb.png": 590972,
	"./emoji/1f574-1f3fc.png": 424837,
	"./emoji/1f574-1f3fd.png": 440170,
	"./emoji/1f574-1f3fe.png": 290931,
	"./emoji/1f574-1f3ff.png": 116440,
	"./emoji/1f574.png": 710631,
	"./emoji/1f575-1f3fb-200d-2640-fe0f.png": 10129,
	"./emoji/1f575-1f3fb.png": 259417,
	"./emoji/1f575-1f3fc-200d-2640-fe0f.png": 452018,
	"./emoji/1f575-1f3fc.png": 662512,
	"./emoji/1f575-1f3fd-200d-2640-fe0f.png": 84815,
	"./emoji/1f575-1f3fd.png": 105359,
	"./emoji/1f575-1f3fe-200d-2640-fe0f.png": 100624,
	"./emoji/1f575-1f3fe.png": 66342,
	"./emoji/1f575-1f3ff-200d-2640-fe0f.png": 210229,
	"./emoji/1f575-1f3ff.png": 591229,
	"./emoji/1f575-fe0f-200d-2640-fe0f.png": 551474,
	"./emoji/1f575-fe0f.png": 252656,
	"./emoji/1f576.png": 43893,
	"./emoji/1f577.png": 807980,
	"./emoji/1f578.png": 887867,
	"./emoji/1f579.png": 173042,
	"./emoji/1f57a-1f3fb.png": 380221,
	"./emoji/1f57a-1f3fc.png": 642740,
	"./emoji/1f57a-1f3fd.png": 205003,
	"./emoji/1f57a-1f3fe.png": 467522,
	"./emoji/1f57a-1f3ff.png": 532057,
	"./emoji/1f57a.png": 446538,
	"./emoji/1f587.png": 795705,
	"./emoji/1f58a.png": 654975,
	"./emoji/1f58b.png": 741412,
	"./emoji/1f58c.png": 783917,
	"./emoji/1f58d.png": 402354,
	"./emoji/1f590-1f3fb.png": 368534,
	"./emoji/1f590-1f3fc.png": 630271,
	"./emoji/1f590-1f3fd.png": 771616,
	"./emoji/1f590-1f3fe.png": 742793,
	"./emoji/1f590-1f3ff.png": 377650,
	"./emoji/1f590.png": 418401,
	"./emoji/1f595-1f3fb.png": 612455,
	"./emoji/1f595-1f3fc.png": 741118,
	"./emoji/1f595-1f3fd.png": 577233,
	"./emoji/1f595-1f3fe.png": 337288,
	"./emoji/1f595-1f3ff.png": 674147,
	"./emoji/1f595.png": 136572,
	"./emoji/1f596-1f3fb.png": 737804,
	"./emoji/1f596-1f3fc.png": 106901,
	"./emoji/1f596-1f3fd.png": 350394,
	"./emoji/1f596-1f3fe.png": 667971,
	"./emoji/1f596-1f3ff.png": 382696,
	"./emoji/1f596.png": 725303,
	"./emoji/1f5a4.png": 821661,
	"./emoji/1f5a5.png": 904980,
	"./emoji/1f5a8.png": 75649,
	"./emoji/1f5b1.png": 844525,
	"./emoji/1f5b2.png": 453846,
	"./emoji/1f5bc.png": 835439,
	"./emoji/1f5c2.png": 579773,
	"./emoji/1f5c3.png": 358644,
	"./emoji/1f5c4.png": 404555,
	"./emoji/1f5d1.png": 394891,
	"./emoji/1f5d2.png": 125040,
	"./emoji/1f5d3.png": 721945,
	"./emoji/1f5dc.png": 795177,
	"./emoji/1f5dd.png": 145206,
	"./emoji/1f5de.png": 199007,
	"./emoji/1f5e1.png": 92996,
	"./emoji/1f5e3.png": 451318,
	"./emoji/1f5ef.png": 662987,
	"./emoji/1f5f3.png": 225507,
	"./emoji/1f5fa.png": 718401,
	"./emoji/1f5fb.png": 687818,
	"./emoji/1f5fc.png": 843027,
	"./emoji/1f5fd.png": 488156,
	"./emoji/1f5fe.png": 54693,
	"./emoji/1f5ff.png": 800686,
	"./emoji/1f600.png": 941357,
	"./emoji/1f601.png": 687460,
	"./emoji/1f602.png": 540671,
	"./emoji/1f603.png": 127382,
	"./emoji/1f604.png": 467465,
	"./emoji/1f605.png": 589344,
	"./emoji/1f606.png": 367675,
	"./emoji/1f607.png": 136498,
	"./emoji/1f608.png": 523701,
	"./emoji/1f609.png": 771436,
	"./emoji/1f60a.png": 269908,
	"./emoji/1f60b.png": 444399,
	"./emoji/1f60c.png": 405382,
	"./emoji/1f60d.png": 338425,
	"./emoji/1f60e.png": 848528,
	"./emoji/1f60f.png": 219819,
	"./emoji/1f610.png": 849826,
	"./emoji/1f611.png": 740331,
	"./emoji/1f612.png": 826512,
	"./emoji/1f613.png": 832761,
	"./emoji/1f614.png": 713990,
	"./emoji/1f615.png": 295535,
	"./emoji/1f616.png": 790420,
	"./emoji/1f617.png": 11549,
	"./emoji/1f618.png": 684426,
	"./emoji/1f619.png": 416339,
	"./emoji/1f61a.png": 672059,
	"./emoji/1f61b.png": 317024,
	"./emoji/1f61c.png": 288201,
	"./emoji/1f61d.png": 913942,
	"./emoji/1f61e.png": 692031,
	"./emoji/1f61f.png": 262116,
	"./emoji/1f620.png": 470035,
	"./emoji/1f621.png": 314826,
	"./emoji/1f622.png": 345409,
	"./emoji/1f623.png": 124280,
	"./emoji/1f624.png": 856919,
	"./emoji/1f625.png": 427694,
	"./emoji/1f626.png": 198053,
	"./emoji/1f627.png": 115164,
	"./emoji/1f628.png": 124651,
	"./emoji/1f629.png": 903522,
	"./emoji/1f62a.png": 88410,
	"./emoji/1f62b.png": 509521,
	"./emoji/1f62c.png": 515656,
	"./emoji/1f62d.png": 95271,
	"./emoji/1f62e.png": 826430,
	"./emoji/1f62f.png": 428533,
	"./emoji/1f630.png": 131368,
	"./emoji/1f631.png": 63409,
	"./emoji/1f632.png": 403514,
	"./emoji/1f633.png": 993347,
	"./emoji/1f634.png": 943948,
	"./emoji/1f635.png": 855573,
	"./emoji/1f636.png": 535198,
	"./emoji/1f637.png": 710983,
	"./emoji/1f638.png": 750400,
	"./emoji/1f639.png": 874601,
	"./emoji/1f63a.png": 364449,
	"./emoji/1f63b.png": 415466,
	"./emoji/1f63c.png": 570675,
	"./emoji/1f63d.png": 870716,
	"./emoji/1f63e.png": 400133,
	"./emoji/1f63f.png": 528334,
	"./emoji/1f640.png": 1369,
	"./emoji/1f641.png": 404464,
	"./emoji/1f642.png": 674315,
	"./emoji/1f643.png": 453186,
	"./emoji/1f644.png": 849533,
	"./emoji/1f645-1f3fb-200d-2640-fe0f.png": 408111,
	"./emoji/1f645-1f3fb-200d-2642-fe0f.png": 911929,
	"./emoji/1f645-1f3fb.png": 431343,
	"./emoji/1f645-1f3fc-200d-2640-fe0f.png": 185840,
	"./emoji/1f645-1f3fc-200d-2642-fe0f.png": 591978,
	"./emoji/1f645-1f3fc.png": 849798,
	"./emoji/1f645-1f3fd-200d-2640-fe0f.png": 643889,
	"./emoji/1f645-1f3fd-200d-2642-fe0f.png": 915463,
	"./emoji/1f645-1f3fd.png": 452217,
	"./emoji/1f645-1f3fe-200d-2640-fe0f.png": 291858,
	"./emoji/1f645-1f3fe-200d-2642-fe0f.png": 19768,
	"./emoji/1f645-1f3fe.png": 445968,
	"./emoji/1f645-1f3ff-200d-2640-fe0f.png": 405899,
	"./emoji/1f645-1f3ff-200d-2642-fe0f.png": 574613,
	"./emoji/1f645-1f3ff.png": 876139,
	"./emoji/1f645-200d-2642-fe0f.png": 856972,
	"./emoji/1f645.png": 628404,
	"./emoji/1f646-1f3fb-200d-2640-fe0f.png": 264118,
	"./emoji/1f646-1f3fb-200d-2642-fe0f.png": 459820,
	"./emoji/1f646-1f3fb.png": 219796,
	"./emoji/1f646-1f3fc-200d-2640-fe0f.png": 18581,
	"./emoji/1f646-1f3fc-200d-2642-fe0f.png": 844491,
	"./emoji/1f646-1f3fc.png": 136477,
	"./emoji/1f646-1f3fd-200d-2640-fe0f.png": 518236,
	"./emoji/1f646-1f3fd-200d-2642-fe0f.png": 10406,
	"./emoji/1f646-1f3fd.png": 948578,
	"./emoji/1f646-1f3fe-200d-2640-fe0f.png": 573067,
	"./emoji/1f646-1f3fe-200d-2642-fe0f.png": 747157,
	"./emoji/1f646-1f3fe.png": 169707,
	"./emoji/1f646-1f3ff-200d-2640-fe0f.png": 914706,
	"./emoji/1f646-1f3ff-200d-2642-fe0f.png": 99640,
	"./emoji/1f646-1f3ff.png": 282064,
	"./emoji/1f646-200d-2642-fe0f.png": 975705,
	"./emoji/1f646.png": 847311,
	"./emoji/1f647-1f3fb-200d-2640-fe0f.png": 750121,
	"./emoji/1f647-1f3fb.png": 417265,
	"./emoji/1f647-1f3fc-200d-2640-fe0f.png": 809642,
	"./emoji/1f647-1f3fc.png": 968872,
	"./emoji/1f647-1f3fd-200d-2640-fe0f.png": 778407,
	"./emoji/1f647-1f3fd.png": 548487,
	"./emoji/1f647-1f3fe-200d-2640-fe0f.png": 846408,
	"./emoji/1f647-1f3fe.png": 372702,
	"./emoji/1f647-1f3ff-200d-2640-fe0f.png": 389101,
	"./emoji/1f647-1f3ff.png": 209429,
	"./emoji/1f647-200d-2640-fe0f.png": 357264,
	"./emoji/1f647.png": 808294,
	"./emoji/1f648.png": 564449,
	"./emoji/1f649.png": 79832,
	"./emoji/1f64a.png": 950400,
	"./emoji/1f64b-1f3fb-200d-2640-fe0f.png": 194778,
	"./emoji/1f64b-1f3fb-200d-2642-fe0f.png": 226528,
	"./emoji/1f64b-1f3fb.png": 240568,
	"./emoji/1f64b-1f3fc-200d-2640-fe0f.png": 563225,
	"./emoji/1f64b-1f3fc-200d-2642-fe0f.png": 928975,
	"./emoji/1f64b-1f3fc.png": 461697,
	"./emoji/1f64b-1f3fd-200d-2640-fe0f.png": 211256,
	"./emoji/1f64b-1f3fd-200d-2642-fe0f.png": 999698,
	"./emoji/1f64b-1f3fd.png": 543982,
	"./emoji/1f64b-1f3fe-200d-2640-fe0f.png": 140119,
	"./emoji/1f64b-1f3fe-200d-2642-fe0f.png": 30337,
	"./emoji/1f64b-1f3fe.png": 973207,
	"./emoji/1f64b-1f3ff-200d-2640-fe0f.png": 287262,
	"./emoji/1f64b-1f3ff-200d-2642-fe0f.png": 440852,
	"./emoji/1f64b-1f3ff.png": 715100,
	"./emoji/1f64b-200d-2642-fe0f.png": 491749,
	"./emoji/1f64b.png": 847963,
	"./emoji/1f64c-1f3fb.png": 411349,
	"./emoji/1f64c-1f3fc.png": 499724,
	"./emoji/1f64c-1f3fd.png": 32771,
	"./emoji/1f64c-1f3fe.png": 442938,
	"./emoji/1f64c-1f3ff.png": 619185,
	"./emoji/1f64c.png": 526418,
	"./emoji/1f64d-1f3fb-200d-2640-fe0f.png": 688468,
	"./emoji/1f64d-1f3fb-200d-2642-fe0f.png": 218078,
	"./emoji/1f64d-1f3fb.png": 741114,
	"./emoji/1f64d-1f3fc-200d-2640-fe0f.png": 512675,
	"./emoji/1f64d-1f3fc-200d-2642-fe0f.png": 49069,
	"./emoji/1f64d-1f3fc.png": 330947,
	"./emoji/1f64d-1f3fd-200d-2640-fe0f.png": 90734,
	"./emoji/1f64d-1f3fd-200d-2642-fe0f.png": 391844,
	"./emoji/1f64d-1f3fd.png": 281548,
	"./emoji/1f64d-1f3fe-200d-2640-fe0f.png": 352877,
	"./emoji/1f64d-1f3fe-200d-2642-fe0f.png": 403555,
	"./emoji/1f64d-1f3fe.png": 193173,
	"./emoji/1f64d-1f3ff-200d-2640-fe0f.png": 326536,
	"./emoji/1f64d-1f3ff-200d-2642-fe0f.png": 237922,
	"./emoji/1f64d-1f3ff.png": 872798,
	"./emoji/1f64d-200d-2642-fe0f.png": 478107,
	"./emoji/1f64d.png": 856397,
	"./emoji/1f64e-1f3fb-200d-2640-fe0f.png": 63391,
	"./emoji/1f64e-1f3fb-200d-2642-fe0f.png": 501097,
	"./emoji/1f64e-1f3fb.png": 686335,
	"./emoji/1f64e-1f3fc-200d-2640-fe0f.png": 229216,
	"./emoji/1f64e-1f3fc-200d-2642-fe0f.png": 209690,
	"./emoji/1f64e-1f3fc.png": 789398,
	"./emoji/1f64e-1f3fd-200d-2640-fe0f.png": 996769,
	"./emoji/1f64e-1f3fd-200d-2642-fe0f.png": 225911,
	"./emoji/1f64e-1f3fd.png": 129481,
	"./emoji/1f64e-1f3fe-200d-2640-fe0f.png": 31170,
	"./emoji/1f64e-1f3fe-200d-2642-fe0f.png": 361960,
	"./emoji/1f64e-1f3fe.png": 735008,
	"./emoji/1f64e-1f3ff-200d-2640-fe0f.png": 174267,
	"./emoji/1f64e-1f3ff-200d-2642-fe0f.png": 312453,
	"./emoji/1f64e-1f3ff.png": 513339,
	"./emoji/1f64e-200d-2642-fe0f.png": 656700,
	"./emoji/1f64e.png": 193156,
	"./emoji/1f64f-1f3fb.png": 247076,
	"./emoji/1f64f-1f3fc.png": 500973,
	"./emoji/1f64f-1f3fd.png": 696114,
	"./emoji/1f64f-1f3fe.png": 410939,
	"./emoji/1f64f-1f3ff.png": 632608,
	"./emoji/1f64f.png": 478431,
	"./emoji/1f680.png": 745189,
	"./emoji/1f681.png": 509276,
	"./emoji/1f682.png": 733207,
	"./emoji/1f683.png": 33710,
	"./emoji/1f684.png": 832193,
	"./emoji/1f685.png": 611064,
	"./emoji/1f686.png": 406675,
	"./emoji/1f687.png": 674762,
	"./emoji/1f688.png": 1885,
	"./emoji/1f689.png": 780756,
	"./emoji/1f68a.png": 582508,
	"./emoji/1f68b.png": 450983,
	"./emoji/1f68c.png": 63294,
	"./emoji/1f68d.png": 415761,
	"./emoji/1f68e.png": 175816,
	"./emoji/1f68f.png": 735056,
	"./emoji/1f690.png": 9530,
	"./emoji/1f691.png": 810755,
	"./emoji/1f692.png": 525480,
	"./emoji/1f693.png": 939697,
	"./emoji/1f694.png": 598686,
	"./emoji/1f695.png": 800647,
	"./emoji/1f696.png": 880588,
	"./emoji/1f697.png": 249685,
	"./emoji/1f698.png": 720530,
	"./emoji/1f699.png": 134747,
	"./emoji/1f69a.png": 926387,
	"./emoji/1f69b.png": 751896,
	"./emoji/1f69c.png": 24609,
	"./emoji/1f69d.png": 341518,
	"./emoji/1f69e.png": 331511,
	"./emoji/1f69f.png": 742780,
	"./emoji/1f6a0.png": 488914,
	"./emoji/1f6a1.png": 903131,
	"./emoji/1f6a2.png": 124800,
	"./emoji/1f6a3-1f3fb-200d-2640-fe0f.png": 580632,
	"./emoji/1f6a3-1f3fb.png": 793166,
	"./emoji/1f6a3-1f3fc-200d-2640-fe0f.png": 32055,
	"./emoji/1f6a3-1f3fc.png": 783159,
	"./emoji/1f6a3-1f3fd-200d-2640-fe0f.png": 330234,
	"./emoji/1f6a3-1f3fd.png": 203544,
	"./emoji/1f6a3-1f3fe-200d-2640-fe0f.png": 726393,
	"./emoji/1f6a3-1f3fe.png": 476257,
	"./emoji/1f6a3-1f3ff-200d-2640-fe0f.png": 789796,
	"./emoji/1f6a3-1f3ff.png": 527274,
	"./emoji/1f6a3-200d-2640-fe0f.png": 950145,
	"./emoji/1f6a3.png": 579625,
	"./emoji/1f6a4.png": 479798,
	"./emoji/1f6a5.png": 76127,
	"./emoji/1f6a6.png": 121476,
	"./emoji/1f6a7.png": 361421,
	"./emoji/1f6a8.png": 261562,
	"./emoji/1f6a9.png": 579139,
	"./emoji/1f6aa.png": 691467,
	"./emoji/1f6ab.png": 209712,
	"./emoji/1f6ac.png": 441817,
	"./emoji/1f6ad.png": 36838,
	"./emoji/1f6ae.png": 321935,
	"./emoji/1f6af.png": 399476,
	"./emoji/1f6b0.png": 752067,
	"./emoji/1f6b1.png": 162234,
	"./emoji/1f6b2.png": 822129,
	"./emoji/1f6b3.png": 373736,
	"./emoji/1f6b4-1f3fb-200d-2640-fe0f.png": 398814,
	"./emoji/1f6b4-1f3fb.png": 377116,
	"./emoji/1f6b4-1f3fc-200d-2640-fe0f.png": 902045,
	"./emoji/1f6b4-1f3fc.png": 460005,
	"./emoji/1f6b4-1f3fd-200d-2640-fe0f.png": 573636,
	"./emoji/1f6b4-1f3fd.png": 93130,
	"./emoji/1f6b4-1f3fe-200d-2640-fe0f.png": 357395,
	"./emoji/1f6b4-1f3fe.png": 248339,
	"./emoji/1f6b4-1f3ff-200d-2640-fe0f.png": 306330,
	"./emoji/1f6b4-1f3ff.png": 902584,
	"./emoji/1f6b4-200d-2640-fe0f.png": 747303,
	"./emoji/1f6b4.png": 953351,
	"./emoji/1f6b5-1f3fb-200d-2640-fe0f.png": 683313,
	"./emoji/1f6b5-1f3fb.png": 805753,
	"./emoji/1f6b5-1f3fc-200d-2640-fe0f.png": 331282,
	"./emoji/1f6b5-1f3fc.png": 799504,
	"./emoji/1f6b5-1f3fd-200d-2640-fe0f.png": 447535,
	"./emoji/1f6b5-1f3fd.png": 784879,
	"./emoji/1f6b5-1f3fe-200d-2640-fe0f.png": 225264,
	"./emoji/1f6b5-1f3fe.png": 203334,
	"./emoji/1f6b5-1f3ff-200d-2640-fe0f.png": 106133,
	"./emoji/1f6b5-1f3ff.png": 984541,
	"./emoji/1f6b5-200d-2640-fe0f.png": 815304,
	"./emoji/1f6b5.png": 777566,
	"./emoji/1f6b6-1f3fb-200d-2640-fe0f.png": 72140,
	"./emoji/1f6b6-1f3fb.png": 812146,
	"./emoji/1f6b6-1f3fc-200d-2640-fe0f.png": 103227,
	"./emoji/1f6b6-1f3fc.png": 526971,
	"./emoji/1f6b6-1f3fd-200d-2640-fe0f.png": 86502,
	"./emoji/1f6b6-1f3fd.png": 363108,
	"./emoji/1f6b6-1f3fe-200d-2640-fe0f.png": 642245,
	"./emoji/1f6b6-1f3fe.png": 617005,
	"./emoji/1f6b6-1f3ff-200d-2640-fe0f.png": 158176,
	"./emoji/1f6b6-1f3ff.png": 803030,
	"./emoji/1f6b6-200d-2640-fe0f.png": 841645,
	"./emoji/1f6b6.png": 614293,
	"./emoji/1f6b7.png": 702668,
	"./emoji/1f6b8.png": 406683,
	"./emoji/1f6b9.png": 85138,
	"./emoji/1f6ba.png": 174186,
	"./emoji/1f6bb.png": 123169,
	"./emoji/1f6bc.png": 638552,
	"./emoji/1f6bd.png": 430071,
	"./emoji/1f6be.png": 287054,
	"./emoji/1f6bf.png": 158853,
	"./emoji/1f6c0-1f3fb.png": 454523,
	"./emoji/1f6c0-1f3fc.png": 705522,
	"./emoji/1f6c0-1f3fd.png": 87085,
	"./emoji/1f6c0-1f3fe.png": 44580,
	"./emoji/1f6c0-1f3ff.png": 958143,
	"./emoji/1f6c0.png": 425112,
	"./emoji/1f6c1.png": 697825,
	"./emoji/1f6c2.png": 748842,
	"./emoji/1f6c3.png": 599603,
	"./emoji/1f6c4.png": 415996,
	"./emoji/1f6c5.png": 733509,
	"./emoji/1f6cb.png": 166394,
	"./emoji/1f6cc.png": 483971,
	"./emoji/1f6cd.png": 553804,
	"./emoji/1f6ce.png": 922901,
	"./emoji/1f6cf.png": 755550,
	"./emoji/1f6d0.png": 856585,
	"./emoji/1f6d1.png": 885408,
	"./emoji/1f6d2.png": 240443,
	"./emoji/1f6e0.png": 186414,
	"./emoji/1f6e1.png": 615639,
	"./emoji/1f6e2.png": 357532,
	"./emoji/1f6e3.png": 440421,
	"./emoji/1f6e4.png": 73546,
	"./emoji/1f6e5.png": 228755,
	"./emoji/1f6e9.png": 107951,
	"./emoji/1f6eb.png": 434988,
	"./emoji/1f6ec.png": 187253,
	"./emoji/1f6f0.png": 85791,
	"./emoji/1f6f3.png": 131140,
	"./emoji/1f6f4.png": 912795,
	"./emoji/1f6f5.png": 498578,
	"./emoji/1f6f6.png": 589289,
	"./emoji/1f910.png": 449501,
	"./emoji/1f911.png": 228372,
	"./emoji/1f912.png": 733487,
	"./emoji/1f913.png": 151942,
	"./emoji/1f914.png": 270713,
	"./emoji/1f915.png": 264464,
	"./emoji/1f916.png": 178283,
	"./emoji/1f917.png": 287778,
	"./emoji/1f918-1f3fb.png": 296962,
	"./emoji/1f918-1f3fc.png": 518091,
	"./emoji/1f918-1f3fd.png": 472180,
	"./emoji/1f918-1f3fe.png": 693309,
	"./emoji/1f918-1f3ff.png": 652070,
	"./emoji/1f918.png": 709157,
	"./emoji/1f919-1f3fb.png": 16135,
	"./emoji/1f919-1f3fc.png": 840350,
	"./emoji/1f919-1f3fd.png": 884913,
	"./emoji/1f919-1f3fe.png": 436520,
	"./emoji/1f919-1f3ff.png": 814851,
	"./emoji/1f919.png": 956892,
	"./emoji/1f91a-1f3fb.png": 19551,
	"./emoji/1f91a-1f3fc.png": 965750,
	"./emoji/1f91a-1f3fd.png": 615721,
	"./emoji/1f91a-1f3fe.png": 491520,
	"./emoji/1f91a-1f3ff.png": 389083,
	"./emoji/1f91a.png": 700068,
	"./emoji/1f91b-1f3fb.png": 319556,
	"./emoji/1f91b-1f3fc.png": 982797,
	"./emoji/1f91b-1f3fd.png": 652818,
	"./emoji/1f91b-1f3fe.png": 974363,
	"./emoji/1f91b-1f3ff.png": 76800,
	"./emoji/1f91b.png": 129983,
	"./emoji/1f91c-1f3fb.png": 584225,
	"./emoji/1f91c-1f3fc.png": 311512,
	"./emoji/1f91c-1f3fd.png": 891127,
	"./emoji/1f91c-1f3fe.png": 901134,
	"./emoji/1f91c-1f3ff.png": 619909,
	"./emoji/1f91c.png": 351894,
	"./emoji/1f91d.png": 726153,
	"./emoji/1f91e-1f3fb.png": 882899,
	"./emoji/1f91e-1f3fc.png": 727690,
	"./emoji/1f91e-1f3fd.png": 94565,
	"./emoji/1f91e-1f3fe.png": 528028,
	"./emoji/1f91e-1f3ff.png": 269783,
	"./emoji/1f91e.png": 754976,
	"./emoji/1f920.png": 104344,
	"./emoji/1f921.png": 377057,
	"./emoji/1f922.png": 428074,
	"./emoji/1f923.png": 278835,
	"./emoji/1f924.png": 95228,
	"./emoji/1f925.png": 412741,
	"./emoji/1f926-1f3fb-200d-2640-fe0f.png": 438593,
	"./emoji/1f926-1f3fb-200d-2642-fe0f.png": 548375,
	"./emoji/1f926-1f3fb.png": 796713,
	"./emoji/1f926-1f3fc-200d-2640-fe0f.png": 21602,
	"./emoji/1f926-1f3fc-200d-2642-fe0f.png": 110216,
	"./emoji/1f926-1f3fc.png": 672512,
	"./emoji/1f926-1f3fd-200d-2640-fe0f.png": 257983,
	"./emoji/1f926-1f3fd-200d-2642-fe0f.png": 491913,
	"./emoji/1f926-1f3fd.png": 684191,
	"./emoji/1f926-1f3fe-200d-2640-fe0f.png": 619264,
	"./emoji/1f926-1f3fe-200d-2642-fe0f.png": 293050,
	"./emoji/1f926-1f3fe.png": 630390,
	"./emoji/1f926-1f3ff-200d-2640-fe0f.png": 369189,
	"./emoji/1f926-1f3ff-200d-2642-fe0f.png": 321435,
	"./emoji/1f926-1f3ff.png": 62157,
	"./emoji/1f926-200d-2640-fe0f.png": 432856,
	"./emoji/1f926-200d-2642-fe0f.png": 367986,
	"./emoji/1f927.png": 683959,
	"./emoji/1f930-1f3fb.png": 803984,
	"./emoji/1f930-1f3fc.png": 810233,
	"./emoji/1f930-1f3fd.png": 207814,
	"./emoji/1f930-1f3fe.png": 789359,
	"./emoji/1f930-1f3ff.png": 767892,
	"./emoji/1f930.png": 431299,
	"./emoji/1f933-1f3fb.png": 297355,
	"./emoji/1f933-1f3fc.png": 76226,
	"./emoji/1f933-1f3fd.png": 472573,
	"./emoji/1f933-1f3fe.png": 251444,
	"./emoji/1f933-1f3ff.png": 986703,
	"./emoji/1f933.png": 569320,
	"./emoji/1f934-1f3fb.png": 945948,
	"./emoji/1f934-1f3fc.png": 28837,
	"./emoji/1f934-1f3fd.png": 661962,
	"./emoji/1f934-1f3fe.png": 300819,
	"./emoji/1f934-1f3ff.png": 955064,
	"./emoji/1f934.png": 148935,
	"./emoji/1f935-1f3fb.png": 374585,
	"./emoji/1f935-1f3fc.png": 145955,
	"./emoji/1f935-1f3fd.png": 837359,
	"./emoji/1f935-1f3fe.png": 772166,
	"./emoji/1f935-1f3ff.png": 553373,
	"./emoji/1f935.png": 973150,
	"./emoji/1f936-1f3fb.png": 380978,
	"./emoji/1f936-1f3fc.png": 95803,
	"./emoji/1f936-1f3fd.png": 931940,
	"./emoji/1f936-1f3fe.png": 185837,
	"./emoji/1f936-1f3ff.png": 371862,
	"./emoji/1f936.png": 293525,
	"./emoji/1f937-1f3fb-200d-2640-fe0f.png": 529783,
	"./emoji/1f937-1f3fb-200d-2642-fe0f.png": 924961,
	"./emoji/1f937-1f3fb.png": 988855,
	"./emoji/1f937-1f3fc-200d-2640-fe0f.png": 187160,
	"./emoji/1f937-1f3fc-200d-2642-fe0f.png": 746610,
	"./emoji/1f937-1f3fc.png": 845838,
	"./emoji/1f937-1f3fd-200d-2640-fe0f.png": 460921,
	"./emoji/1f937-1f3fd-200d-2642-fe0f.png": 440751,
	"./emoji/1f937-1f3fd.png": 681953,
	"./emoji/1f937-1f3fe-200d-2640-fe0f.png": 968634,
	"./emoji/1f937-1f3fe-200d-2642-fe0f.png": 930048,
	"./emoji/1f937-1f3fe.png": 197336,
	"./emoji/1f937-1f3ff-200d-2640-fe0f.png": 266611,
	"./emoji/1f937-1f3ff-200d-2642-fe0f.png": 83645,
	"./emoji/1f937-1f3ff.png": 371827,
	"./emoji/1f937-200d-2640-fe0f.png": 939502,
	"./emoji/1f937-200d-2642-fe0f.png": 240612,
	"./emoji/1f938-1f3fb-200d-2640-fe0f.png": 583450,
	"./emoji/1f938-1f3fb-200d-2642-fe0f.png": 615200,
	"./emoji/1f938-1f3fb.png": 146808,
	"./emoji/1f938-1f3fc-200d-2640-fe0f.png": 951897,
	"./emoji/1f938-1f3fc-200d-2642-fe0f.png": 801295,
	"./emoji/1f938-1f3fc.png": 367937,
	"./emoji/1f938-1f3fd-200d-2640-fe0f.png": 599928,
	"./emoji/1f938-1f3fd-200d-2642-fe0f.png": 388370,
	"./emoji/1f938-1f3fd.png": 450222,
	"./emoji/1f938-1f3fe-200d-2640-fe0f.png": 12439,
	"./emoji/1f938-1f3fe-200d-2642-fe0f.png": 902657,
	"./emoji/1f938-1f3fe.png": 395799,
	"./emoji/1f938-1f3ff-200d-2640-fe0f.png": 159582,
	"./emoji/1f938-1f3ff-200d-2642-fe0f.png": 829524,
	"./emoji/1f938-1f3ff.png": 137692,
	"./emoji/1f938-200d-2640-fe0f.png": 804315,
	"./emoji/1f938-200d-2642-fe0f.png": 852069,
	"./emoji/1f939-1f3fb-200d-2640-fe0f.png": 866797,
	"./emoji/1f939-1f3fb-200d-2642-fe0f.png": 917475,
	"./emoji/1f939-1f3fb.png": 317589,
	"./emoji/1f939-1f3fc-200d-2640-fe0f.png": 604654,
	"./emoji/1f939-1f3fc-200d-2642-fe0f.png": 905764,
	"./emoji/1f939-1f3fc.png": 405964,
	"./emoji/1f939-1f3fd-200d-2640-fe0f.png": 26595,
	"./emoji/1f939-1f3fd-200d-2642-fe0f.png": 46637,
	"./emoji/1f939-1f3fd.png": 455363,
	"./emoji/1f939-1f3fe-200d-2640-fe0f.png": 202388,
	"./emoji/1f939-1f3fe-200d-2642-fe0f.png": 215646,
	"./emoji/1f939-1f3fe.png": 865530,
	"./emoji/1f939-1f3ff-200d-2640-fe0f.png": 227817,
	"./emoji/1f939-1f3ff-200d-2642-fe0f.png": 790111,
	"./emoji/1f939-1f3ff.png": 525425,
	"./emoji/1f939-200d-2640-fe0f.png": 998380,
	"./emoji/1f939-200d-2642-fe0f.png": 802678,
	"./emoji/1f93a.png": 853418,
	"./emoji/1f93c-200d-2640-fe0f.png": 702906,
	"./emoji/1f93c-200d-2642-fe0f.png": 664320,
	"./emoji/1f93d-1f3fb-200d-2640-fe0f.png": 593134,
	"./emoji/1f93d-1f3fb-200d-2642-fe0f.png": 894244,
	"./emoji/1f93d-1f3fb.png": 318348,
	"./emoji/1f93d-1f3fc-200d-2640-fe0f.png": 855277,
	"./emoji/1f93d-1f3fc-200d-2642-fe0f.png": 905955,
	"./emoji/1f93d-1f3fc.png": 229973,
	"./emoji/1f93d-1f3fd-200d-2640-fe0f.png": 190868,
	"./emoji/1f93d-1f3fd-200d-2642-fe0f.png": 204126,
	"./emoji/1f93d-1f3fd.png": 777914,
	"./emoji/1f93d-1f3fe-200d-2640-fe0f.png": 15075,
	"./emoji/1f93d-1f3fe-200d-2642-fe0f.png": 35117,
	"./emoji/1f93d-1f3fe.png": 367747,
	"./emoji/1f93d-1f3ff-200d-2640-fe0f.png": 275818,
	"./emoji/1f93d-1f3ff-200d-2642-fe0f.png": 869680,
	"./emoji/1f93d-1f3ff.png": 505768,
	"./emoji/1f93d-200d-2640-fe0f.png": 747703,
	"./emoji/1f93d-200d-2642-fe0f.png": 659233,
	"./emoji/1f93e-1f3fb-200d-2640-fe0f.png": 825473,
	"./emoji/1f93e-1f3fb-200d-2642-fe0f.png": 808407,
	"./emoji/1f93e-1f3fb.png": 998057,
	"./emoji/1f93e-1f3fc-200d-2640-fe0f.png": 577634,
	"./emoji/1f93e-1f3fc-200d-2642-fe0f.png": 475656,
	"./emoji/1f93e-1f3fc.png": 543232,
	"./emoji/1f93e-1f3fd-200d-2640-fe0f.png": 792063,
	"./emoji/1f93e-1f3fd-200d-2642-fe0f.png": 745673,
	"./emoji/1f93e-1f3fd.png": 494559,
	"./emoji/1f93e-1f3fe-200d-2640-fe0f.png": 365248,
	"./emoji/1f93e-1f3fe-200d-2642-fe0f.png": 403834,
	"./emoji/1f93e-1f3fe.png": 898230,
	"./emoji/1f93e-1f3ff-200d-2640-fe0f.png": 313125,
	"./emoji/1f93e-1f3ff-200d-2642-fe0f.png": 312987,
	"./emoji/1f93e-1f3ff.png": 779853,
	"./emoji/1f93e-200d-2640-fe0f.png": 405080,
	"./emoji/1f93e-200d-2642-fe0f.png": 964530,
	"./emoji/1f940.png": 865646,
	"./emoji/1f941.png": 811223,
	"./emoji/1f942.png": 553116,
	"./emoji/1f943.png": 636005,
	"./emoji/1f944.png": 752778,
	"./emoji/1f945.png": 907987,
	"./emoji/1f947.png": 783361,
	"./emoji/1f948.png": 748166,
	"./emoji/1f949.png": 787183,
	"./emoji/1f94a.png": 533223,
	"./emoji/1f94b.png": 114220,
	"./emoji/1f950.png": 535817,
	"./emoji/1f951.png": 80992,
	"./emoji/1f952.png": 919675,
	"./emoji/1f953.png": 170674,
	"./emoji/1f954.png": 552237,
	"./emoji/1f955.png": 26084,
	"./emoji/1f956.png": 939647,
	"./emoji/1f957.png": 161558,
	"./emoji/1f958.png": 673041,
	"./emoji/1f959.png": 433096,
	"./emoji/1f95a.png": 74128,
	"./emoji/1f95b.png": 987947,
	"./emoji/1f95c.png": 97442,
	"./emoji/1f95d.png": 259165,
	"./emoji/1f95e.png": 38036,
	"./emoji/1f980.png": 34090,
	"./emoji/1f981.png": 672947,
	"./emoji/1f982.png": 498456,
	"./emoji/1f983.png": 983073,
	"./emoji/1f984.png": 146958,
	"./emoji/1f985.png": 289975,
	"./emoji/1f986.png": 489340,
	"./emoji/1f987.png": 18757,
	"./emoji/1f988.png": 871810,
	"./emoji/1f989.png": 92939,
	"./emoji/1f98a.png": 611971,
	"./emoji/1f98b.png": 749992,
	"./emoji/1f98c.png": 682033,
	"./emoji/1f98d.png": 637470,
	"./emoji/1f98e.png": 329607,
	"./emoji/1f98f.png": 562572,
	"./emoji/1f990.png": 203989,
	"./emoji/1f991.png": 318540,
	"./emoji/1f9c0.png": 149267,
	"./emoji/203c-fe0f.png": 880840,
	"./emoji/2049-fe0f.png": 417121,
	"./emoji/2122-fe0f.png": 959001,
	"./emoji/2139-fe0f.png": 27953,
	"./emoji/2194-fe0f.png": 154668,
	"./emoji/2195-fe0f.png": 609059,
	"./emoji/2196-fe0f.png": 193462,
	"./emoji/2197-fe0f.png": 558381,
	"./emoji/2198-fe0f.png": 163248,
	"./emoji/2199-fe0f.png": 633351,
	"./emoji/21a9-fe0f.png": 398927,
	"./emoji/21aa-fe0f.png": 625959,
	"./emoji/231a-fe0f.png": 89357,
	"./emoji/231b-fe0f.png": 907532,
	"./emoji/2328-fe0f.png": 186057,
	"./emoji/23e9.png": 939549,
	"./emoji/23ea.png": 603061,
	"./emoji/23eb.png": 958,
	"./emoji/23ec.png": 388647,
	"./emoji/23ed.png": 597128,
	"./emoji/23ee.png": 353425,
	"./emoji/23ef.png": 228762,
	"./emoji/23f0.png": 361009,
	"./emoji/23f1.png": 463144,
	"./emoji/23f2.png": 748419,
	"./emoji/23f3.png": 430842,
	"./emoji/23f8.png": 748905,
	"./emoji/23f9.png": 294080,
	"./emoji/23fa.png": 689560,
	"./emoji/24c2-fe0f.png": 688443,
	"./emoji/25aa-fe0f.png": 451939,
	"./emoji/25ab-fe0f.png": 447798,
	"./emoji/25b6-fe0f.png": 121377,
	"./emoji/25c0-fe0f.png": 593342,
	"./emoji/25fb-fe0f.png": 99145,
	"./emoji/25fc-fe0f.png": 74818,
	"./emoji/25fd-fe0f.png": 824291,
	"./emoji/25fe-fe0f.png": 499500,
	"./emoji/2600-fe0f.png": 835632,
	"./emoji/2601-fe0f.png": 305735,
	"./emoji/2602-fe0f.png": 677802,
	"./emoji/2603-fe0f.png": 34161,
	"./emoji/2604-fe0f.png": 175188,
	"./emoji/260e-fe0f.png": 730843,
	"./emoji/2611-fe0f.png": 596486,
	"./emoji/2614-fe0f.png": 267737,
	"./emoji/2615-fe0f.png": 688978,
	"./emoji/2618-fe0f.png": 938565,
	"./emoji/261d-1f3fb.png": 424058,
	"./emoji/261d-1f3fc.png": 13891,
	"./emoji/261d-1f3fd.png": 964492,
	"./emoji/261d-1f3fe.png": 876117,
	"./emoji/261d-1f3ff.png": 555742,
	"./emoji/261d-fe0f.png": 650665,
	"./emoji/2620-fe0f.png": 498146,
	"./emoji/2622-fe0f.png": 396168,
	"./emoji/2623-fe0f.png": 367007,
	"./emoji/2626-fe0f.png": 424588,
	"./emoji/262a-fe0f.png": 565273,
	"./emoji/262e-fe0f.png": 600637,
	"./emoji/262f-fe0f.png": 191740,
	"./emoji/2638-fe0f.png": 378743,
	"./emoji/2639-fe0f.png": 219808,
	"./emoji/263a-fe0f.png": 488,
	"./emoji/2648-fe0f.png": 877764,
	"./emoji/2649-fe0f.png": 343323,
	"./emoji/264a-fe0f.png": 893923,
	"./emoji/264b-fe0f.png": 478326,
	"./emoji/264c-fe0f.png": 843245,
	"./emoji/264d-fe0f.png": 628136,
	"./emoji/264e-fe0f.png": 206591,
	"./emoji/264f-fe0f.png": 531202,
	"./emoji/2650-fe0f.png": 113225,
	"./emoji/2651-fe0f.png": 88898,
	"./emoji/2652-fe0f.png": 362943,
	"./emoji/2653-fe0f.png": 419688,
	"./emoji/2660-fe0f.png": 137406,
	"./emoji/2663-fe0f.png": 721099,
	"./emoji/2665-fe0f.png": 788817,
	"./emoji/2666-fe0f.png": 852304,
	"./emoji/2668-fe0f.png": 899414,
	"./emoji/267b-fe0f.png": 817141,
	"./emoji/267f-fe0f.png": 770801,
	"./emoji/2692.png": 327715,
	"./emoji/2693-fe0f.png": 802836,
	"./emoji/2694-fe0f.png": 178161,
	"./emoji/2696-fe0f.png": 449735,
	"./emoji/2697-fe0f.png": 979632,
	"./emoji/2699-fe0f.png": 9846,
	"./emoji/269b-fe0f.png": 874843,
	"./emoji/269c-fe0f.png": 409284,
	"./emoji/26a0-fe0f.png": 302061,
	"./emoji/26a1-fe0f.png": 937142,
	"./emoji/26aa-fe0f.png": 918438,
	"./emoji/26ab-fe0f.png": 50323,
	"./emoji/26b0-fe0f.png": 760274,
	"./emoji/26b1-fe0f.png": 339033,
	"./emoji/26bd-fe0f.png": 439190,
	"./emoji/26be-fe0f.png": 631629,
	"./emoji/26c4-fe0f.png": 757891,
	"./emoji/26c5-fe0f.png": 979532,
	"./emoji/26c8.png": 584071,
	"./emoji/26ce.png": 942850,
	"./emoji/26cf.png": 456857,
	"./emoji/26d1.png": 908507,
	"./emoji/26d3.png": 101353,
	"./emoji/26d4-fe0f.png": 95112,
	"./emoji/26e9.png": 283036,
	"./emoji/26ea-fe0f.png": 86146,
	"./emoji/26f0.png": 430488,
	"./emoji/26f1.png": 703201,
	"./emoji/26f2-fe0f.png": 13348,
	"./emoji/26f3-fe0f.png": 599419,
	"./emoji/26f4.png": 421372,
	"./emoji/26f5-fe0f.png": 816385,
	"./emoji/26f7.png": 10103,
	"./emoji/26f8.png": 636272,
	"./emoji/26f9-1f3fb-200d-2640-fe0f.png": 549480,
	"./emoji/26f9-1f3fb.png": 857790,
	"./emoji/26f9-1f3fc-200d-2640-fe0f.png": 141383,
	"./emoji/26f9-1f3fc.png": 245479,
	"./emoji/26f9-1f3fd-200d-2640-fe0f.png": 738698,
	"./emoji/26f9-1f3fd.png": 453960,
	"./emoji/26f9-1f3fe-200d-2640-fe0f.png": 961161,
	"./emoji/26f9-1f3fe.png": 210257,
	"./emoji/26f9-1f3ff-200d-2640-fe0f.png": 18676,
	"./emoji/26f9-1f3ff.png": 85594,
	"./emoji/26f9-fe0f-200d-2640-fe0f.png": 659893,
	"./emoji/26f9-fe0f.png": 993341,
	"./emoji/26fa-fe0f.png": 259925,
	"./emoji/26fd-fe0f.png": 715658,
	"./emoji/2702-fe0f.png": 482505,
	"./emoji/2705.png": 227058,
	"./emoji/2708-fe0f.png": 724167,
	"./emoji/2709-fe0f.png": 254064,
	"./emoji/270a-1f3fb.png": 312849,
	"./emoji/270a-1f3fc.png": 556552,
	"./emoji/270a-1f3fd.png": 348071,
	"./emoji/270a-1f3fe.png": 960382,
	"./emoji/270a-1f3ff.png": 562485,
	"./emoji/270a.png": 534342,
	"./emoji/270b-1f3fb.png": 826186,
	"./emoji/270b-1f3fc.png": 981395,
	"./emoji/270b-1f3fd.png": 626524,
	"./emoji/270b-1f3fe.png": 193061,
	"./emoji/270b-1f3ff.png": 939054,
	"./emoji/270b.png": 315549,
	"./emoji/270c-1f3fb.png": 346639,
	"./emoji/270c-1f3fc.png": 61542,
	"./emoji/270c-1f3fd.png": 950169,
	"./emoji/270c-1f3fe.png": 234416,
	"./emoji/270c-1f3ff.png": 199819,
	"./emoji/270c-fe0f.png": 330930,
	"./emoji/270d-1f3fb.png": 307912,
	"./emoji/270d-1f3fc.png": 64209,
	"./emoji/270d-1f3fd.png": 711742,
	"./emoji/270d-1f3fe.png": 99431,
	"./emoji/270d-1f3ff.png": 230956,
	"./emoji/270d-fe0f.png": 397459,
	"./emoji/270f-fe0f.png": 808541,
	"./emoji/2712-fe0f.png": 375256,
	"./emoji/2714-fe0f.png": 978150,
	"./emoji/2716-fe0f.png": 969628,
	"./emoji/271d-fe0f.png": 430070,
	"./emoji/2721-fe0f.png": 317846,
	"./emoji/2728.png": 557745,
	"./emoji/2733-fe0f.png": 679873,
	"./emoji/2734-fe0f.png": 876836,
	"./emoji/2744-fe0f.png": 535367,
	"./emoji/2747-fe0f.png": 823978,
	"./emoji/274c.png": 261368,
	"./emoji/274e.png": 564782,
	"./emoji/2753.png": 458259,
	"./emoji/2754.png": 560860,
	"./emoji/2755.png": 796773,
	"./emoji/2757-fe0f.png": 852471,
	"./emoji/2763-fe0f.png": 462968,
	"./emoji/2764-fe0f.png": 215805,
	"./emoji/2795.png": 548081,
	"./emoji/2796.png": 888186,
	"./emoji/2797.png": 478019,
	"./emoji/27a1-fe0f.png": 411209,
	"./emoji/27b0.png": 495225,
	"./emoji/27bf.png": 181119,
	"./emoji/2934-fe0f.png": 426174,
	"./emoji/2935-fe0f.png": 700309,
	"./emoji/2b05-fe0f.png": 482199,
	"./emoji/2b06-fe0f.png": 723578,
	"./emoji/2b07-fe0f.png": 372417,
	"./emoji/2b1b-fe0f.png": 229207,
	"./emoji/2b1c-fe0f.png": 799104,
	"./emoji/2b50-fe0f.png": 664677,
	"./emoji/2b55-fe0f.png": 651674,
	"./emoji/3030-fe0f.png": 577428,
	"./emoji/303d-fe0f.png": 265184,
	"./emoji/3297-fe0f.png": 390845,
	"./emoji/3299-fe0f.png": 880727,
	"./emoji/boomea.png": 829945,
	"./emoji/bowtie.png": 778372,
	"./emoji/feelsgood.png": 879168,
	"./emoji/finnadie.png": 135512,
	"./emoji/goberserk.png": 950552,
	"./emoji/godmode.png": 274731,
	"./emoji/hurtrealbad.png": 234932,
	"./emoji/neckbeard.png": 798221,
	"./emoji/octocat.png": 747883,
	"./emoji/rage1.png": 913912,
	"./emoji/rage2.png": 709523,
	"./emoji/rage3.png": 977610,
	"./emoji/rage4.png": 48037,
	"./emoji/shipit.png": 765807,
	"./emoji/suspect.png": 141215,
	"./emoji/trollface.png": 817758,
	"./filesOverlay.png": 585700,
	"./gitlabLogo.png": 473563,
	"./google-play-badge.png": 39881,
	"./googleLogo.png": 733259,
	"./icons/attachment.svg": 869238,
	"./icons/book-open.svg": 52851,
	"./icons/boomea.svg": 836510,
	"./icons/calendar.svg": 354919,
	"./icons/chat-alt.svg": 139925,
	"./icons/chat-filled.svg": 682276,
	"./icons/chat.svg": 706715,
	"./icons/circle-plus.svg": 647038,
	"./icons/close.svg": 763807,
	"./icons/communications-history/call.svg": 703700,
	"./icons/communications-history/chat.svg": 668910,
	"./icons/communications-history/inbound-rejected.svg": 576842,
	"./icons/communications-history/incoming.svg": 135904,
	"./icons/communications-history/meeting.svg": 965335,
	"./icons/communications-history/mic.svg": 574269,
	"./icons/communications-history/missed-call.svg": 829000,
	"./icons/communications-history/note.svg": 842304,
	"./icons/communications-history/out-going.svg": 616265,
	"./icons/communications-history/sms.svg": 85003,
	"./icons/communications-history/voicemail.svg": 463559,
	"./icons/community.svg": 290600,
	"./icons/contact-address.svg": 843516,
	"./icons/contact-alt.svg": 284765,
	"./icons/contact-comments.svg": 577578,
	"./icons/contact-envelope.svg": 44272,
	"./icons/contact-history.svg": 325660,
	"./icons/contact-icon.svg": 93207,
	"./icons/contact-others.svg": 842949,
	"./icons/contact-phone.svg": 542120,
	"./icons/contact-website.svg": 542611,
	"./icons/deligate.svg": 653308,
	"./icons/end-call.svg": 270977,
	"./icons/envelope.svg": 630433,
	"./icons/external.svg": 961988,
	"./icons/filter-cross.svg": 234516,
	"./icons/filter-plus.svg": 62956,
	"./icons/fullscreen.svg": 921282,
	"./icons/meeting-history.svg": 743051,
	"./icons/more-plus.svg": 446671,
	"./icons/move-vertical.svg": 712053,
	"./icons/phone.svg": 207607,
	"./icons/printer.svg": 872107,
	"./icons/settings.svg": 551694,
	"./icons/share.svg": 503602,
	"./icons/sms-fill.svg": 848802,
	"./icons/star-fill.svg": 649797,
	"./icons/star.svg": 85697,
	"./icons/tags.svg": 302670,
	"./icons/trash.svg": 602825,
	"./icons/user.svg": 25932,
	"./icons/users.svg": 457703,
	"./icons/voice-mail.svg": 856995,
	"./img_trans.gif": 476090,
	"./incoming_webhook.jpg": 268429,
	"./info__icon.png": 209222,
	"./ios.png": 624948,
	"./iphone-6-mockup.png": 67757,
	"./linux.png": 697209,
	"./mac.png": 35826,
	"./next.png": 754608,
	"./nexus-6p-mockup.png": 980455,
	"./oauth_icon.png": 118512,
	"./office365Logo.png": 352902,
	"./outgoing_webhook.jpg": 607295,
	"./parking-slot.svg": 949429,
	"./pixel.png": 854171,
	"./presence/available.svg": 649867,
	"./presence/meeting-available.svg": 905647,
	"./presence/meeting-away.svg": 432428,
	"./presence/meeting-oncall.svg": 383029,
	"./presence/on-call.svg": 94914,
	"./presence/parking-slot.svg": 391455,
	"./presence/ringing.gif": 140732,
	"./presence/ringing.svg": 145584,
	"./prev.png": 1844,
	"./quick-call-phone.png": 481974,
	"./redfavicon.ico": 460934,
	"./ring.mp3": 777246,
	"./ringtone.mp3": 385734,
	"./short1_ringtone.mp3": 430984,
	"./short2_ringtone.mp3": 565385,
	"./simple1_ringtone.mp3": 676624,
	"./simple2_ringtone.mp3": 102865,
	"./simplifi/bfbfbf.svg": 388928,
	"./simplifi/blueicon.png": 953128,
	"./simplifi/boomea-bg.jpg": 673982,
	"./simplifi/boomea-logo.svg": 35777,
	"./simplifi/boomea/about.svg": 125689,
	"./simplifi/boomea/account-settings-white.svg": 470439,
	"./simplifi/boomea/account-settings.svg": 974791,
	"./simplifi/boomea/add-presence.svg": 294819,
	"./simplifi/boomea/advaced-settings.svg": 203060,
	"./simplifi/boomea/advanced-notifications.svg": 863059,
	"./simplifi/boomea/appchat.png": 874306,
	"./simplifi/boomea/appphone.png": 697182,
	"./simplifi/boomea/apprecord.png": 664431,
	"./simplifi/boomea/assign-contact.svg": 775894,
	"./simplifi/boomea/blue-lock.svg": 412054,
	"./simplifi/boomea/blue-unlock.svg": 308503,
	"./simplifi/boomea/boomea-white.svg": 200185,
	"./simplifi/boomea/boomealogo.png": 595911,
	"./simplifi/boomea/calendar-blue.svg": 548381,
	"./simplifi/boomea/calendar-gray.svg": 507392,
	"./simplifi/boomea/calendar.svg": 319268,
	"./simplifi/boomea/call-recording-blue-phone.svg": 243230,
	"./simplifi/boomea/call-recording-grey-phone.svg": 364311,
	"./simplifi/boomea/chat-access-blue.svg": 428688,
	"./simplifi/boomea/chat-access-white.svg": 928499,
	"./simplifi/boomea/chat.svg": 631612,
	"./simplifi/boomea/chevron-arrow-down.svg": 881816,
	"./simplifi/boomea/clear-search.svg": 792918,
	"./simplifi/boomea/clipboard.svg": 692380,
	"./simplifi/boomea/communication-history/call.svg": 286000,
	"./simplifi/boomea/communication-history/chat.svg": 639298,
	"./simplifi/boomea/communication-history/inbound-rejected.svg": 93886,
	"./simplifi/boomea/communication-history/incoming.svg": 56324,
	"./simplifi/boomea/communication-history/mic.svg": 218793,
	"./simplifi/boomea/communication-history/missed-call.svg": 372828,
	"./simplifi/boomea/communication-history/out-going.svg": 318925,
	"./simplifi/boomea/communication-history/sms.svg": 247575,
	"./simplifi/boomea/communication-history/voicemail.svg": 295139,
	"./simplifi/boomea/community-white.svg": 442153,
	"./simplifi/boomea/contact-details/birthday.svg": 711013,
	"./simplifi/boomea/contact-details/callrecording.svg": 476043,
	"./simplifi/boomea/contact-details/chat.svg": 351680,
	"./simplifi/boomea/contact-details/cog.svg": 134535,
	"./simplifi/boomea/contact-details/envelope.svg": 759522,
	"./simplifi/boomea/contact-details/history.svg": 558706,
	"./simplifi/boomea/contact-details/location.svg": 819279,
	"./simplifi/boomea/contact-details/meeting.svg": 845465,
	"./simplifi/boomea/contact-details/missed-call.svg": 52806,
	"./simplifi/boomea/contact-details/others.svg": 48151,
	"./simplifi/boomea/contact-details/outgoing-call.svg": 457325,
	"./simplifi/boomea/contact-details/phone.svg": 871658,
	"./simplifi/boomea/contact-details/received-call.svg": 863440,
	"./simplifi/boomea/contact-details/received-mail.svg": 619173,
	"./simplifi/boomea/contact-details/rejected-call.svg": 809273,
	"./simplifi/boomea/contact-details/sent-chat.svg": 322143,
	"./simplifi/boomea/contact-details/voice-mail.svg": 985792,
	"./simplifi/boomea/contact-details/voicemail.svg": 204325,
	"./simplifi/boomea/contact-details/website.svg": 948289,
	"./simplifi/boomea/contact-details/white-down.svg": 566790,
	"./simplifi/boomea/contact-plus-white.svg": 303967,
	"./simplifi/boomea/contact-settings-white.svg": 993608,
	"./simplifi/boomea/contacts-icon-blue.png": 344805,
	"./simplifi/boomea/contacts-icon-blue.svg": 420410,
	"./simplifi/boomea/contacts-icon-white.svg": 241729,
	"./simplifi/boomea/contacts/chat-comment.svg": 715994,
	"./simplifi/boomea/contacts/chat-off.OLD.png": 341724,
	"./simplifi/boomea/contacts/chat-off.png": 474689,
	"./simplifi/boomea/contacts/chat-offOLD2.png": 269122,
	"./simplifi/boomea/contacts/chat-on.OLD.png": 385274,
	"./simplifi/boomea/contacts/chat-on.png": 598431,
	"./simplifi/boomea/contacts/chat-onOLD2.png": 376208,
	"./simplifi/boomea/contacts/chat.svg": 559462,
	"./simplifi/boomea/contacts/contact-assign.svg": 125002,
	"./simplifi/boomea/contacts/contact-plus.svg": 398153,
	"./simplifi/boomea/contacts/contact-search.svg": 776005,
	"./simplifi/boomea/contacts/contact-settings-blue.svg": 1927,
	"./simplifi/boomea/contacts/contact-settings.svg": 197958,
	"./simplifi/boomea/contacts/download.svg": 678404,
	"./simplifi/boomea/contacts/email-off.png": 768343,
	"./simplifi/boomea/contacts/email-offOLD2.png": 71368,
	"./simplifi/boomea/contacts/email-on.png": 169069,
	"./simplifi/boomea/contacts/email-onOLD2.png": 602134,
	"./simplifi/boomea/contacts/email.png": 69923,
	"./simplifi/boomea/contacts/google-plus.svg": 473026,
	"./simplifi/boomea/contacts/office365.svg": 669532,
	"./simplifi/boomea/contacts/phone-off.OLD.png": 642166,
	"./simplifi/boomea/contacts/phone-off.png": 716603,
	"./simplifi/boomea/contacts/phone-offOLD2.svg": 291331,
	"./simplifi/boomea/contacts/phone-on.OLD.png": 324316,
	"./simplifi/boomea/contacts/phone-on.png": 342209,
	"./simplifi/boomea/contacts/phone-onOLD2.svg": 438253,
	"./simplifi/boomea/contacts/toggle-down-white.svg": 372685,
	"./simplifi/boomea/contacts/toggle-down.svg": 549833,
	"./simplifi/boomea/contacts/toggle-up-dark.svg": 863679,
	"./simplifi/boomea/contacts/toggle-up-white.svg": 142050,
	"./simplifi/boomea/contacts/toggle-up.svg": 776486,
	"./simplifi/boomea/copy-link-blue.svg": 134467,
	"./simplifi/boomea/copy-link.svg": 260122,
	"./simplifi/boomea/delete-white.svg": 548311,
	"./simplifi/boomea/delete.svg": 336887,
	"./simplifi/boomea/desktop-notifications.svg": 825669,
	"./simplifi/boomea/desktop-settings.svg": 5264,
	"./simplifi/boomea/down-round.svg": 502345,
	"./simplifi/boomea/download.svg": 414126,
	"./simplifi/boomea/edit-presence.svg": 416104,
	"./simplifi/boomea/fax/cancelled.svg": 337947,
	"./simplifi/boomea/fax/fax-icon.svg": 624479,
	"./simplifi/boomea/fax/inbound-fax.svg": 616291,
	"./simplifi/boomea/fax/outbound-fax.svg": 498688,
	"./simplifi/boomea/fax/pdf.svg": 398348,
	"./simplifi/boomea/fax/success-icon.svg": 976735,
	"./simplifi/boomea/filter-cross.png": 368124,
	"./simplifi/boomea/filter-plus.png": 370890,
	"./simplifi/boomea/fullscreen.svg": 278709,
	"./simplifi/boomea/grey-lock.svg": 430757,
	"./simplifi/boomea/head-cancel.svg": 638063,
	"./simplifi/boomea/head-phones.svg": 619986,
	"./simplifi/boomea/help.svg": 393375,
	"./simplifi/boomea/history.svg": 302782,
	"./simplifi/boomea/icons/audio.svg": 489407,
	"./simplifi/boomea/icons/blue/history.svg": 185670,
	"./simplifi/boomea/icons/blue/meeting.svg": 649965,
	"./simplifi/boomea/icons/blue/mic.svg": 551823,
	"./simplifi/boomea/icons/blue/voice-mail.svg": 135564,
	"./simplifi/boomea/icons/chat.svg": 665677,
	"./simplifi/boomea/icons/company-directory.svg": 970882,
	"./simplifi/boomea/icons/conference-center.svg": 363697,
	"./simplifi/boomea/icons/conference-center2.svg": 813841,
	"./simplifi/boomea/icons/contacts-icon-white.svg": 379146,
	"./simplifi/boomea/icons/contacts.svg": 18140,
	"./simplifi/boomea/icons/fax-icon.svg": 68190,
	"./simplifi/boomea/icons/head-cancel.svg": 313564,
	"./simplifi/boomea/icons/head-phones.svg": 817965,
	"./simplifi/boomea/icons/history.svg": 962465,
	"./simplifi/boomea/icons/meeting.svg": 195098,
	"./simplifi/boomea/icons/mic.svg": 568284,
	"./simplifi/boomea/icons/notification-white.svg": 439778,
	"./simplifi/boomea/icons/operator-console.svg": 486927,
	"./simplifi/boomea/icons/other.svg": 749179,
	"./simplifi/boomea/icons/phone-disable.svg": 869302,
	"./simplifi/boomea/icons/phone.svg": 291993,
	"./simplifi/boomea/icons/presence.svg": 508992,
	"./simplifi/boomea/icons/quick-call.svg": 511357,
	"./simplifi/boomea/icons/sms.svg": 651666,
	"./simplifi/boomea/icons/video.svg": 711360,
	"./simplifi/boomea/icons/voice-mail.svg": 222701,
	"./simplifi/boomea/icons/word.svg": 490843,
	"./simplifi/boomea/icons/zip.svg": 54904,
	"./simplifi/boomea/join-meeting.svg": 272146,
	"./simplifi/boomea/logo.svg": 265503,
	"./simplifi/boomea/logout.svg": 490284,
	"./simplifi/boomea/meeting-3.png": 403338,
	"./simplifi/boomea/meeting-history.svg": 814898,
	"./simplifi/boomea/meeting.svg": 681333,
	"./simplifi/boomea/mic.svg": 716743,
	"./simplifi/boomea/mobile-blue-notifications.svg": 694086,
	"./simplifi/boomea/mobile-notifications.svg": 141423,
	"./simplifi/boomea/move-v.svg": 277600,
	"./simplifi/boomea/notification-white.svg": 779019,
	"./simplifi/boomea/operator-console.svg": 248830,
	"./simplifi/boomea/operator-console/available.svg": 955586,
	"./simplifi/boomea/operator-console/call-orange.png": 262295,
	"./simplifi/boomea/operator-console/call-orange.svg": 675192,
	"./simplifi/boomea/operator-console/call-red-yellow.gif": 8172,
	"./simplifi/boomea/operator-console/call-yellow.gif": 652202,
	"./simplifi/boomea/operator-console/call-yellow.png": 181117,
	"./simplifi/boomea/operator-console/intercom.svg": 902996,
	"./simplifi/boomea/operator-console/on-call.svg": 813483,
	"./simplifi/boomea/operator-console/ringing.gif": 886185,
	"./simplifi/boomea/operator-console/ringing.svg": 76533,
	"./simplifi/boomea/parking-slot-disabled.svg": 118752,
	"./simplifi/boomea/parking-slot.svg": 461727,
	"./simplifi/boomea/passcode.svg": 249062,
	"./simplifi/boomea/pencil.svg": 546661,
	"./simplifi/boomea/phone-toggle-off.svg": 660783,
	"./simplifi/boomea/phone.svg": 229182,
	"./simplifi/boomea/pickup.svg": 555938,
	"./simplifi/boomea/presence-blue.svg": 616786,
	"./simplifi/boomea/profile.svg": 40493,
	"./simplifi/boomea/quick-call.svg": 883576,
	"./simplifi/boomea/reload.svg": 496469,
	"./simplifi/boomea/remove.svg": 595458,
	"./simplifi/boomea/save.svg": 711709,
	"./simplifi/boomea/search.svg": 957446,
	"./simplifi/boomea/settings.svg": 742741,
	"./simplifi/boomea/share-blue.svg": 697840,
	"./simplifi/boomea/share.svg": 953651,
	"./simplifi/boomea/short-cut.svg": 202739,
	"./simplifi/boomea/start-meeting.svg": 474022,
	"./simplifi/boomea/time.svg": 850401,
	"./simplifi/boomea/toggle-off.svg": 398326,
	"./simplifi/boomea/visibility-off.svg": 417190,
	"./simplifi/boomea/visibility.svg": 122054,
	"./simplifi/boomea/voice-mail.svg": 742644,
	"./simplifi/boomea/webphone/contacts-icon.svg": 898906,
	"./simplifi/boomea/white/add-presence.svg": 475933,
	"./simplifi/boomea/white/edit-presence.svg": 629526,
	"./simplifi/boomea/white/filter-cross.png": 153494,
	"./simplifi/boomea/white/filter-plus.png": 677736,
	"./simplifi/boomea/white/toggle-off.svg": 168112,
	"./simplifi/compdir/company-directory-blue.svg": 345457,
	"./simplifi/compdir/company-directory3.svg": 938115,
	"./simplifi/compdir/compdir-call-gray.png": 694449,
	"./simplifi/compdir/compdir-call-green.png": 53691,
	"./simplifi/compdir/compdir-call-red.png": 359259,
	"./simplifi/compdir/compdir-call-white.png": 891869,
	"./simplifi/compdir/compdir-call-yellow.png": 607940,
	"./simplifi/compdir/pencil-alt-solid.svg": 236266,
	"./simplifi/compdir/sms-off.svg": 470392,
	"./simplifi/compdir/sms-original.svg": 771872,
	"./simplifi/compdir/sms.svg": 770580,
	"./simplifi/compdir/trash-alt-solid.svg": 987981,
	"./simplifi/email.png": 367815,
	"./simplifi/favicon/android-chrome-192x192.png": 586975,
	"./simplifi/favicon/apple-touch-icon-120x120.png": 999795,
	"./simplifi/favicon/apple-touch-icon-144x144.png": 418631,
	"./simplifi/favicon/apple-touch-icon-152x152.png": 546311,
	"./simplifi/favicon/apple-touch-icon-57x57.png": 421287,
	"./simplifi/favicon/apple-touch-icon-60x60.png": 28987,
	"./simplifi/favicon/apple-touch-icon-72x72.png": 509933,
	"./simplifi/favicon/apple-touch-icon-76x76.png": 828005,
	"./simplifi/favicon/favicon-16x16.png": 648183,
	"./simplifi/favicon/favicon-32x32.png": 500943,
	"./simplifi/favicon/favicon-96x96.png": 546167,
	"./simplifi/favicon/redfavicon-16x16.png": 623978,
	"./simplifi/icon50x50.png": 28052,
	"./simplifi/icon64x64.png": 443126,
	"./simplifi/icon_WS.png": 616011,
	"./simplifi/icons/audio.png": 165962,
	"./simplifi/icons/audio.svg": 331973,
	"./simplifi/icons/chat.svg": 205663,
	"./simplifi/icons/code.png": 327849,
	"./simplifi/icons/code.svg": 539582,
	"./simplifi/icons/email.png": 187892,
	"./simplifi/icons/excel.png": 506493,
	"./simplifi/icons/excel.svg": 851266,
	"./simplifi/icons/generic.png": 872899,
	"./simplifi/icons/generic.svg": 386868,
	"./simplifi/icons/image.png": 623343,
	"./simplifi/icons/image.svg": 976320,
	"./simplifi/icons/lock.png": 425315,
	"./simplifi/icons/logo.svg": 892268,
	"./simplifi/icons/patch.png": 785234,
	"./simplifi/icons/pdf.png": 44462,
	"./simplifi/icons/pdf.svg": 116009,
	"./simplifi/icons/phone-green.svg": 600421,
	"./simplifi/icons/phone-grey.svg": 638341,
	"./simplifi/icons/phone-red.svg": 614537,
	"./simplifi/icons/phone-yellow.svg": 137868,
	"./simplifi/icons/ppt.png": 404176,
	"./simplifi/icons/ppt.svg": 419967,
	"./simplifi/icons/presentation.svg": 952585,
	"./simplifi/icons/search-icon.svg": 679445,
	"./simplifi/icons/user.png": 101975,
	"./simplifi/icons/video.png": 63165,
	"./simplifi/icons/video.svg": 407938,
	"./simplifi/icons/word.png": 911226,
	"./simplifi/icons/word.svg": 768405,
	"./simplifi/icons/zip.svg": 9302,
	"./simplifi/lightbluelogo.svg": 683917,
	"./simplifi/load.gif": 778920,
	"./simplifi/load.png": 900315,
	"./simplifi/lock.png": 657114,
	"./simplifi/logo-email.png": 498257,
	"./simplifi/logo.png": 137642,
	"./simplifi/logoWhite.png": 167391,
	"./simplifi/logo_compact.png": 114907,
	"./simplifi/read.svg": 184660,
	"./simplifi/status_green.png": 765221,
	"./simplifi/status_red.png": 361877,
	"./simplifi/status_yellow.png": 60790,
	"./simplifi/user.png": 994166,
	"./simplifi/waiting/chat.png": 144541,
	"./simplifi/waiting/company-directory.png": 33536,
	"./simplifi/waiting/conference-center.png": 586692,
	"./simplifi/waiting/contacts.png": 951368,
	"./simplifi/waiting/meetings.png": 91469,
	"./simplifi/waiting/presence.png": 390424,
	"./simplifi/waiting/schedule-meeting.png": 172300,
	"./simplifi/waiting/webphone.png": 186381,
	"./slash_command_icon.jpg": 123096,
	"./test.mp3": 515780,
	"./test.png": 218791,
	"./test/1f448-1f3fe_control.png": 118991,
	"./test/1f471-1f3fb_control.png": 470000,
	"./test/1f6b5-1f3ff-200d-2640-fe0f_control.png": 518545,
	"./testgif.gif": 747266,
	"./testjpg.jpg": 958086,
	"./themes/axia/full-logo-dark.svg": 986969,
	"./themes/axia/full-logo.svg": 380900,
	"./themes/axia/simplifi-bg.jpg": 248445,
	"./themes/axia/small-logo-grey.svg": 657924,
	"./themes/axia/small-logo.svg": 455956,
	"./themes/boomea/full-logo-dark.svg": 748739,
	"./themes/boomea/full-logo.svg": 551346,
	"./themes/boomea/small-logo.svg": 927894,
	"./themes/code_themes/github.png": 265332,
	"./themes/code_themes/monokai.png": 832343,
	"./themes/code_themes/solarized-dark.png": 211651,
	"./themes/code_themes/solarized-light.png": 177659,
	"./themes/mattermost.png": 805252,
	"./themes/mattermost_dark.png": 471365,
	"./themes/organization.png": 176403,
	"./themes/simplifi/full-logo-dark.svg": 985969,
	"./themes/simplifi/full-logo.svg": 939212,
	"./themes/simplifi/simplifi-bg.jpg": 212885,
	"./themes/simplifi/small-logo-grey.svg": 841660,
	"./themes/simplifi/small-logo.svg": 674268,
	"./themes/windows_dark.png": 587552,
	"./tutorialTip.gif": 47001,
	"./tutorialTipWhite.gif": 373212,
	"./warning.png": 293711,
	"./webhook_icon.jpg": 280106,
	"./windows.png": 63124
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 456070;